var HA;
(function (HA) {
    HA.IMG_OBSERVER = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const image = entry.target;
                image.src = image.dataset.src;
                HA.IMG_OBSERVER.unobserve(image);
            }
        });
    });
    function getDataRepository() {
        if (!HA.DATAREPO) {
            HA.DATAREPO = new HA.Core.Repository.Data();
        }
        return HA.DATAREPO;
    }
    HA.getDataRepository = getDataRepository;
    function getService(id) {
        return getAppService().getService(id);
    }
    HA.getService = getService;
    function getWebPageService() {
        return getAppService().getWebPageService();
    }
    HA.getWebPageService = getWebPageService;
    function setAppService(appService) {
        HA.APPSERVICE = appService;
    }
    HA.setAppService = setAppService;
    function getAppService() {
        return HA.APPSERVICE;
    }
    HA.getAppService = getAppService;
    function setService4App(appService) {
        HA.SERVICE4APP = appService;
    }
    HA.setService4App = setService4App;
    function getService4App() {
        return HA.SERVICE4APP;
    }
    HA.getService4App = getService4App;
    function timeout(func, time) {
        return setTimeout(func, time);
    }
    HA.timeout = timeout;
    function setNotification(notification) {
        HA.NOTIFICATION = notification;
    }
    HA.setNotification = setNotification;
    function log(msg) {
        if (HA.NOTIFICATION) {
            HA.NOTIFICATION.log(msg);
        }
        else {
            log2([isDebug(), msg]);
        }
    }
    HA.log = log;
    function log2(msg) {
        console.log(msg);
    }
    HA.log2 = log2;
    function setAppId(id) {
        HA.HAAPPID = id;
    }
    HA.setAppId = setAppId;
    function getAppId() {
        return HA.HAAPPID;
    }
    HA.getAppId = getAppId;
    function lazyloadImage(img) {
        HA.IMG_OBSERVER.observe(img);
    }
    HA.lazyloadImage = lazyloadImage;
    function notifyUser(msg) {
        log(msg);
    }
    HA.notifyUser = notifyUser;
    function isDebug() {
        if (HA.NOTIFICATION) {
            return HA.NOTIFICATION.isDebug();
        }
        return false;
    }
    HA.isDebug = isDebug;
    function createService(namespace, serviceName, data) {
        try {
            return new (namespace)[serviceName](data);
        }
        catch (e) {
            throw e;
        }
    }
    HA.createService = createService;
    function ptime(...data) {
        log2("time:");
        const date = new Date();
        log2(date.getMilliseconds() + " - " + date.toUTCString());
        if (data) {
            log2(data);
        }
    }
    HA.ptime = ptime;
    function toObj(data) {
        const obj = Object.create(null);
        if (data instanceof Map) {
            data.forEach((v, k) => {
                obj[k] = v;
            });
        }
        return obj;
    }
    HA.toObj = toObj;
    function toMap(data, map) {
        map = map || new Map();
        if (data instanceof Map) {
            data.forEach((v, k) => {
                map.set(k, v);
            });
        }
        else {
            if (data) {
                Object.keys(data).forEach((key) => {
                    map.set(key, data[key]);
                });
            }
        }
        return map;
    }
    HA.toMap = toMap;
})(HA || (HA = {}));
var HA;
(function (HA) {
    class HAObject {
        constructor(data) {
            this.initialize(data);
        }
        getElement(useTag) {
            let element = this.get("element");
            if (!element) {
                const tag = this.getTag();
                if (tag && (useTag || !(tag instanceof HA.Core.HTML.Tag))) {
                    element = tag.getElement();
                }
            }
            return element;
        }
        getTag() {
            return this.get("tag");
        }
        setTag(tag) {
            return this.addToData("tag", tag);
        }
        get(id) {
            return this.getData().get(id);
        }
        remove(id) {
            this.getData().delete(id);
        }
        has(id) {
            return this.getData().has(id);
        }
        hasNot(id) {
            return !this.has(id);
        }
        getData() {
            if (!this.data) {
                this.data = new Map();
            }
            return this.data;
        }
        getServiceManager() {
            return this.get("services");
        }
        updateData(data) {
            const me = this;
            data.forEach((v, k) => {
                me.addToData(k, v);
            });
        }
        addToData(name, data) {
            return this.getData().set(name, data);
        }
        initialize(data) {
            if (data instanceof Map) {
                this.data = data;
            }
            else if (data instanceof Object) {
                this.data = HA.toMap(data);
            }
            const services = this.get("services");
            if (services && !(services instanceof HA.ServiceManager)) {
                this.addToData("services", new HA.ServiceManager(HA.toMap(services)));
            }
        }
        addServices(services) {
            return this.getServiceManager().addServices(services);
        }
        addService(serviceName, func) {
            return this.getServiceManager().addService(serviceName, func);
        }
        getServices(names) {
            return this.getServiceManager().getServices(names);
        }
        getService(name) {
            return this.getServiceManager().getService(name);
        }
    }
    HA.HAObject = HAObject;
})(HA || (HA = {}));
var HA;
(function (HA) {
    class ServiceManager extends HA.HAObject {
        addServices(services) {
            services.forEach((func, name) => {
                this.addService(name, func);
            });
        }
        addService(serviceName, func) {
            this.__getService().set(serviceName, func);
        }
        getServices(names) {
            const result = new Map();
            names.forEach((name) => {
                result.set(name, this.getService(name));
            });
            return result;
        }
        getService(name) {
            return this.__getService().get(name);
        }
        initialize(data) {
            if (data) {
                super.initialize({ __services: data });
            }
        }
        __getService() {
            return this.get("__services");
        }
    }
    HA.ServiceManager = ServiceManager;
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller_1) {
            class Controller extends HA.HAObject {
                click() {
                    const data = HA.toMap(this.get("click"));
                    switch (data.get("func")) {
                        case "toggleApp":
                            HA.getWebPageService().toggleApp(data);
                            break;
                        case "showApp":
                            HA.getWebPageService().showApp(data);
                            break;
                        case "reloadApp":
                            HA.getWebPageService().reloadApp(data);
                            break;
                        case "showPreviousApp":
                            HA.getWebPageService().showPreviousApp();
                            break;
                        case "toggleQMenu":
                            HA.getWebPageService().toggleQMenu();
                            break;
                        default:
                            break;
                    }
                }
                initControllers() {
                    const me = this;
                    const tag = this.getTag();
                    const controllersData = HA.toMap(this.get("controllers"));
                    controllersData.delete("pm");
                    const controllers = new Map();
                    controllersData.forEach((controllerData) => {
                        controllerData = HA.toMap(controllerData);
                        const cname = controllerData.get("n");
                        const cn = this.getControllerClass(cname);
                        if (cn) {
                            const data = controllerData;
                            data.set("services", me.getServiceManager());
                            data.set("parentTag", tag);
                            data.set("appId", this.get("_id") || this.get("id"));
                            if (this.has("pfunc")) {
                                data.set("pfunc", this.get("pfunc"));
                            }
                            controllers.set(cname, new cn(data));
                        }
                    });
                }
                getControllerClass(name) {
                    switch (name) {
                        case "rl":
                            return HA.Core.Controller.Page.SearchableController;
                        case "m":
                            return HA.Core.Controller.Page.MenuController;
                    }
                    return HA.Core.Controller.Page.SearchableController;
                }
                watch4Reload(func) {
                    const me = this;
                    me.w4reload = (event) => {
                        me.w4rListener(func);
                    };
                    document.addEventListener("scroll", me.w4reload);
                }
                w4rListener(func) {
                    const element = document.scrollingElement;
                    const a = element.scrollTop + element.clientHeight;
                    if (a * 1.1 > element.scrollHeight) {
                        func();
                    }
                }
                removeWatch4Reload() {
                    const me = this;
                    document.removeEventListener("scroll", me.w4reload);
                }
                getDataRepository() {
                    if (this.hasNot("dataRepository")) {
                        this.addToData("dataRepository", new HA.Core.Repository.Data());
                    }
                    return this.get("dataRepository");
                }
            }
            Controller_1.Controller = Controller;
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Page;
            (function (Page) {
                class ResultListController extends Controller.Controller {
                }
                Page.ResultListController = ResultListController;
            })(Page = Controller.Page || (Controller.Page = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity_1) {
            class Entity extends HA.HAObject {
                static genId() {
                    return "ID" + Entity.getUUId();
                }
                static getUUId() {
                    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                        const r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    });
                }
                setId(id) {
                    return this.addToData("id", id);
                }
                getId() {
                    return this.get("id") || this.get("_id");
                }
                initialize(data) {
                    super.initialize(data);
                    if (!this.getId()) {
                        this.setId(Entity.genId());
                    }
                }
            }
            Entity_1.Entity = Entity;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML_1) {
            class HTML extends HA.HAObject {
            }
            HTML_1.HTML = HTML;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Tag extends HTML.HTML {
                static createElement(name) {
                    return document.createElement(name);
                }
                addAttribute(name, value) {
                    this.setAttribute(name, this.translate(value));
                }
                addAttributes(attributes) {
                    const me = this;
                    attributes.forEach((a) => {
                        if (a instanceof Map) {
                            me.addAttribute(a.get("n"), a.get("v"));
                        }
                        else {
                            me.addAttribute(a.n, a.v);
                        }
                    });
                }
                equals(value) {
                    return this === value;
                }
                getChildren() {
                    const els = this.getElement().childNodes;
                    const result = [];
                    for (const el of els) {
                        result.push(new Tag(el));
                    }
                    return result;
                }
                fixHeight() {
                    const t = this.getElement();
                    const cs = window.getComputedStyle(t);
                    t.style.height = "inherit";
                    const height = parseInt(cs.getPropertyValue("border-top-width"), 10)
                        + parseInt(cs.getPropertyValue("padding-top"), 10)
                        + t.scrollHeight
                        + parseInt(cs.getPropertyValue("padding-bottom"), 10)
                        + parseInt(cs.getPropertyValue("border-bottom-width"), 10);
                    t.style.height = height + "px";
                }
                focus() {
                    this.getElement().focus();
                }
                insertOnTop(tag) {
                    const el = this.getElement();
                    el.insertBefore(tag.getElement(), el.firstChild);
                }
                show() {
                    this.removeClass("hide");
                    this.addClass("show");
                    this.getElement().style.display = this.get("visibility");
                }
                hide(defaut) {
                    this.removeClass("show");
                    this.addToData("visibility", this.getVisibility(defaut));
                    this.addClass("hide");
                }
                countChildren() {
                    return this.getElement().childNodes.length;
                }
                clear() {
                    const element = this.getElement();
                    if (element) {
                        element.innerHTML = "";
                    }
                    return this;
                }
                getContent() {
                    return this.getElement().innerHTML;
                }
                getStripText() {
                    const text = this.getText();
                    return text.replace(/<[^>]*>/g, "");
                }
                getText() {
                    const t = this.getElement().textContent || this.getElement().innerText;
                    return t;
                }
                addClasses(names) {
                    names.forEach((c) => {
                        this.addClass(c);
                    });
                }
                addClass(name) {
                    if (name && (typeof name === "string") && name.startsWith("#")) {
                        name = this.translate(name);
                    }
                    this.getElement().classList.add(name);
                }
                removeClasses(names) {
                    names.forEach((c) => {
                        this.removeClass(c);
                    });
                }
                removeClass(name) {
                    this.getElement().classList.remove(name);
                }
                onClick(func, blockClickDelay = 1000) {
                    const me = this;
                    this.addListener("click", (e) => {
                        if (me.isDisabled()) {
                            return;
                        }
                        me.disable();
                        func(e);
                        HA.timeout(() => {
                            me.enable();
                        }, blockClickDelay);
                    });
                    me.enable();
                }
                isDisabled() {
                    return this.getAttribute("e") !== "1";
                }
                disable() {
                    return this.addAttribute("e", "");
                }
                enable() {
                    return this.addAttribute("e", "1");
                }
                onChange(func) {
                    this.addListener("change", func);
                }
                setAttribute(name, value) {
                    this.getElement().setAttribute(name, value);
                }
                getAttributes(names, skipNull) {
                    const element = this.getElement();
                    const result = new Map();
                    if (element) {
                        names.forEach((name) => {
                            const v = element.getAttribute(name);
                            if (!skipNull || v) {
                                result.set(name, v);
                            }
                        });
                    }
                    return result;
                }
                getId() {
                    return this.get("id");
                }
                setId(id) {
                    this.addToData("id", id);
                    this.getElement().setAttribute("id", id);
                }
                getValue() {
                    return this.getElement().value;
                }
                querySelector(filter) {
                    return this.getElement().querySelector(filter);
                }
                getElementId() {
                    return this.getAttribute("id");
                }
                getAttribute(name) {
                    return this.getElement().getAttribute(name);
                }
                setText(text) {
                    this.getElement().innerText = text;
                }
                appendChild(element) {
                    if (element instanceof HA.HAObject) {
                        element = element.getElement();
                    }
                    this.getElement().appendChild(element);
                }
                addFistChild(element) {
                    if (element instanceof HA.HAObject) {
                        element = element.getElement();
                    }
                    this.getElement().insertAdjacentElement("afterbegin", element);
                }
                removeById(id) {
                    this.getElement().removeChild(this.findElementById(id));
                }
                findByAttribute(attributeName) {
                    const element = this.findElementByAttribute(attributeName);
                    if (element) {
                        return new Tag(element);
                    }
                    return null;
                }
                findElementByAttribute(attributeName) {
                    const element = this.getElement() || this.getParentElement() || document;
                    return element.querySelector("[" + attributeName + "]");
                }
                findElementByQuery(name) {
                    const element = this.getElement() || this.getParentElement() || document;
                    return element.querySelector(name);
                }
                findByQuery(name) {
                    const element = this.getElement() || this.getParentElement() || document;
                    return new Tag(element.querySelector(name));
                }
                findById(id, useDoc = false) {
                    const element = this.findElementById(id, useDoc);
                    if (element) {
                        return new Tag(element);
                    }
                    return null;
                }
                findElementById(id, useDoc = false) {
                    try {
                        const element = (useDoc) ? document : this.getElement() || this.getParentElement() || document;
                        return element.querySelector("#" + id + "");
                    }
                    catch (e) {
                        return null;
                    }
                }
                findByTag(tagName) {
                    const element = this.getElement() || this.getParentElement() || document;
                    return element.querySelector("" + tagName + "");
                }
                fetchByTagName(tagName) {
                    const element = this.getElement() || this.getParentElement() || document;
                    const els = element.querySelectorAll(tagName);
                    const result = [];
                    for (const el of els) {
                        result.push(new Tag(el));
                    }
                    return result;
                }
                fetchByAttribute(attributeName) {
                    const element = this.getElement() || this.getParentElement() || document;
                    const els = element.querySelectorAll("[" + attributeName + "]");
                    const result = [];
                    for (const el of els) {
                        result.push(new Tag(el));
                    }
                    return result;
                }
                invisible() {
                    this.addClass("invisible");
                }
                getTagName() {
                    return this.get("_tn") || "div";
                }
                addListener(name, func) {
                    if ((typeof func) === "function") {
                        this.getElement().addEventListener(name, (event) => {
                            func(event);
                            event.stopPropagation();
                        }, { passive: true });
                    }
                }
                translate(word, translation) {
                    if (!word || !(typeof word === "string") || !word.startsWith("#")) {
                        return word;
                    }
                    translation = translation || HA.toMap(this.get("trans"));
                    const word2 = translation.get(word.substr(1));
                    if (word2 !== undefined) {
                        return word2;
                    }
                    return null;
                }
                scrollIntoView() {
                    this.getElement().scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                }
                hasTrans(word, translation) {
                    if (!word || !(typeof word === "string") || !word.startsWith("#")) {
                        return false;
                    }
                    translation = translation || HA.toMap(this.get("trans"));
                    const word2 = translation.get(word.substr(1));
                    if (word2 !== undefined) {
                        return true;
                    }
                    return false;
                }
                createByType(data, main) {
                    HA.Core.HTML.Service.HtmlService.createByType(data, main, HA.toMap(this.get("trans")));
                }
                translateAll(list) {
                    const rep = new Map();
                    const me = this;
                    list.forEach((v, k) => {
                        rep.set(k, me.translate(v));
                    });
                    return rep;
                }
                trans(id) {
                    return this.translate(this.getData().get(id));
                }
                createByTypeAndAddAll(children, tag) {
                    if (typeof children === "string" || typeof children === "number") {
                        const tchildren = this.translate(children);
                        if (this instanceof HTML.Span || this instanceof HTML.P) {
                            this.setText(tchildren);
                        }
                        else {
                            this.appendChild(new HTML.Span(tchildren));
                        }
                        return;
                    }
                    else if (children && Array.isArray(children) || children instanceof Map) {
                        const me = this;
                        const trans = this.get("trans");
                        try {
                            children.forEach((item) => {
                                if (typeof item === "string" || typeof item === "number") {
                                    const titem = this.translate(item);
                                    if (this instanceof HTML.Span) {
                                        this.setText(titem);
                                    }
                                    else {
                                        this.appendChild(new HTML.Span(titem));
                                    }
                                    return;
                                }
                                const nitem = HA.toMap(item);
                                if (nitem.size === 0) {
                                    return;
                                }
                                if (trans) {
                                    nitem.set("trans", trans);
                                }
                                me.createByType(nitem, tag);
                            });
                        }
                        catch (e) {
                            HA.log("ooups!");
                            HA.ptime(e);
                            throw e;
                        }
                    }
                }
                getVisibility(defaut) {
                    return this.getElement().style.display || defaut;
                }
                searchAndAddElement() {
                    let param;
                    let element;
                    param = this.get("id");
                    if (param) {
                        element = this.findElementById(param);
                    }
                    if (!element) {
                        param = this.get("attribute");
                        if (param) {
                            element = this.findElementByAttribute(param);
                        }
                        if (!element) {
                            param = this.get("html");
                            if (param) {
                                const el = document.createElement("div");
                                el.innerHTML = this.translate(param);
                                element = el.firstChild;
                            }
                            if (!element) {
                                param = this.get("tagName");
                                if (param) {
                                    element = this.findByTag(param);
                                }
                                else {
                                    this.createSelf();
                                    return;
                                }
                            }
                        }
                    }
                    this.setElement(element);
                }
                setElement(element) {
                    return this.addToData("element", element);
                }
                getParentElement() {
                    return this.get("pelement");
                }
                initialize(data) {
                    if ((data instanceof Object)
                        && !(data instanceof Map)
                        && !(data instanceof Element)
                        && !(data instanceof HA.HAObject)) {
                        data = HA.toMap(data);
                    }
                    if (data instanceof Map && data.has("tag")) {
                        const t = data.get("tag");
                        data.set("element", t.getElement());
                    }
                    else {
                        if (data instanceof Element) {
                            data = HA.toMap({ element: data });
                        }
                        else if (data instanceof HA.HAObject) {
                            data = HA.toMap({ element: data.getElement() });
                        }
                    }
                    super.initialize(data);
                    if (!this.getElement()) {
                        this.searchAndAddElement();
                    }
                    if (typeof data === "string") {
                        this.setText(this.translate(data));
                    }
                    if (this.has("txt")) {
                        this.setText(this.translate(this.get("txt")));
                    }
                    if (this.has("onClick")) {
                        this.onClick(this.get("onClick"));
                    }
                    else if (this.has("click")) {
                        this.onClick(this.get("click"));
                    }
                    if (this.has("onChange")) {
                        this.onChange(this.get("onChange"));
                    }
                    if (this.has("className")) {
                        this.addClass(this.get("className"));
                    }
                    if (this.has("classes")) {
                        this.addClasses(this.get("classes"));
                    }
                    if (this.has("class")) {
                        const _class = this.get("class");
                        if (typeof _class === "string") {
                            this.addClass(_class);
                        }
                        else {
                            this.addClasses(_class);
                        }
                    }
                    if (this.has("attributes")) {
                        this.addAttributes(this.get("attributes"));
                    }
                    if (this.has("-events")) {
                        this.initEvents(this.get("-events"));
                    }
                    if (this.has("eid")) {
                        this.setId(this.translate(this.get("eid")));
                    }
                }
                initEvents(events) {
                    const me = this;
                    events.forEach((func, name) => {
                        me.addListener(name, func);
                    });
                }
                createSelf() {
                    if (!this.get("element")) {
                        this.setElement(Tag.createElement(this.getTagName()));
                    }
                    if (this.has("c")) {
                        this.createByTypeAndAddAll(this.get("c"), this);
                    }
                }
                replaceValues(data) {
                    if (data === "undefined" || (typeof data === "number")) {
                        return data;
                    }
                    const r = new RegExp("#.+");
                    if ((typeof data === "string") && !(r.test(data))) {
                        return data;
                    }
                    if ((typeof data === "string")) {
                        return this.translate(data);
                    }
                    if (data instanceof Map || Array.isArray(data) || typeof data === "object") {
                        const d = HA.toMap(data);
                        if (d.has("norepl")) {
                            return data;
                        }
                        const me = this;
                        const data2 = new Map();
                        data.forEach((item, index) => {
                            let v = item;
                            if (!(typeof item === "string") && !(typeof item === "number")) {
                                v = HA.toMap(v);
                            }
                            const v2 = me.replaceValues(v);
                            data[index] = v2;
                            data2.set(index, v2);
                        });
                        return data2;
                    }
                    return data;
                }
            }
            HTML.Tag = Tag;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            var Tag = HA.Core.HTML.Tag;
            class App extends Entity.Entity {
                setLocalId(id) {
                    this.addToData("lid", id);
                }
                getLocalId() {
                    if (!this.has("lid")) {
                        this.setLocalId(HA.Core.Entity.Entity.genId());
                    }
                    return this.get("lid");
                }
                setPosition(position) {
                    this.addToData("_y", position);
                }
                getPosition() {
                    return this.get("_y") || 0;
                }
                savePosition() {
                    this.addToData("_y", window.scrollY);
                }
                isNotCachable() {
                    return !this.isCachable();
                }
                isCachable() {
                    return this.get("cachable");
                }
                isViewed() {
                    return this.get("viewed");
                }
                setViewed(val) {
                    this.addToData("viewed", val);
                }
                isNotNavigable() {
                    return !this.isNavigable();
                }
                isNavigable() {
                    return this.get("navigable");
                }
                hasUrl() {
                    return this.get("url") !== undefined;
                }
                getUrl() {
                    return this.get("url");
                }
                getName() {
                    return this.get("appTitle");
                }
                getInfo() {
                    const d = this.getTag().getAttributes(["appname", "apptitle"]);
                    if (d && d.get("appname")) {
                        return HA.toMap({ appName: d.get("appname"), appTitle: d.get("apptitle") });
                    }
                    return HA.toMap({ appTitle: this.get("appTitle"), appName: this.get("appName") });
                }
                getQMenu() {
                    let qm = this.get("qmenu");
                    if (qm instanceof Map) {
                        return qm;
                    }
                    qm = HA.toMap(this.get("qmenu"));
                    this.addToData("qmenu", qm);
                    return qm;
                }
                setController(controller) {
                    return this.addToData("controller", controller);
                }
                getController() {
                    return this.get("controller");
                }
                initialize(data) {
                    super.initialize(data);
                    if (!this.has("cachable")) {
                        this.addToData("cachable", true);
                    }
                    if (!this.has("navigable")) {
                        this.addToData("navigable", true);
                    }
                    if (this.has("fid")) {
                        this.addToData("id", this.get("id") + this.get("fid"));
                    }
                    this.createTag(data);
                    const controllerName = this.get("controllerName");
                    if (controllerName) {
                        const controllerNamespace = this.getControllerNamespace(this.get("controllerNamespace"));
                        const cdata = HA.toMap(this.getData());
                        this.setController(HA.createService(controllerNamespace, controllerName, cdata));
                    }
                    if (this.has("msg")) {
                        HA.log(this.get("msg"));
                    }
                    const animation = this.get("animation");
                    if (typeof animation === "object") {
                        this.addToData("animation", HA.toMap(animation));
                    }
                    this.intro();
                }
                outro() {
                    this.savePosition();
                    return;
                    this.playAnimation("outro");
                }
                intro() {
                    HA.timeout(() => {
                        window.scrollTo(0, this.getPosition());
                    }, 100);
                    return;
                    if (this.isViewed()) {
                        return;
                    }
                    this.playAnimation("intro");
                }
                playAnimation(name) {
                    const animation = this.get("animation");
                    if (!animation || !this.getTag()) {
                        return;
                    }
                    const helper = {
                        add: (classes) => {
                            if (!classes) {
                                return;
                            }
                            if (typeof classes === "string") {
                                this.getTag().addClass(classes);
                            }
                            else if (classes) {
                                this.getTag().addClasses(classes);
                            }
                        },
                        remove: (classes) => {
                            if (!classes) {
                                return;
                            }
                            if (typeof classes === "string") {
                                this.getTag().removeClass(classes);
                            }
                            else if (classes) {
                                this.getTag().removeClasses(classes);
                            }
                        }
                    };
                    if (animation instanceof Map && animation.get(name)) {
                        helper.add(animation.get(name));
                        HA.timeout(() => {
                            helper.remove(animation.get(name));
                        }, 1000);
                    }
                    else if (typeof animation === "string") {
                        helper.add(animation);
                        HA.timeout(() => {
                            helper.remove(animation);
                        }, 3000);
                    }
                }
                createTag(data) {
                    this.addToData("tag", new Tag(data));
                }
                getControllerNamespace(name) {
                    let n;
                    switch (name) {
                        case "HA.Core.Controller.Navigation":
                            n = HA.Core.Controller.Navigation;
                            break;
                        case "HA.Core.Controller.Menu":
                            n = HA.Core.Controller.Menu;
                            break;
                        case "HA.Core.Controller.Page":
                            n = HA.Core.Controller.Page;
                            break;
                        default:
                            n = HA.Core.Service;
                            break;
                    }
                    return n;
                }
            }
            Entity.App = App;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Div extends HTML.Tag {
            }
            HTML.Div = Div;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Container extends HTML.Div {
                replaceChildren(elements) {
                    this.clear();
                    this.appendChildren(elements);
                }
                appendChildren(elements) {
                    const me = this;
                    elements.forEach((element) => {
                        me.appendChild(element);
                    });
                }
                replaceByTag(tag) {
                    this.clear();
                    const me = this;
                    if (tag) {
                        setTimeout(() => {
                            me.clear();
                            me.appendChild(tag);
                        }, 0);
                    }
                }
                createByType(data, main) {
                    const t = data.get("t");
                    let tag = null;
                    switch (t) {
                        case "__":
                            tag = new HTML.Div(data.get("d"));
                            tag.addClass("t1");
                            break;
                        default:
                            super.createByType(data, main);
                            break;
                    }
                    if (tag) {
                        main.appendChild(tag);
                    }
                }
            }
            HTML.Container = Container;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            var AppContainer = HA.Core.HTML.Container;
            class AppManager extends Entity.Entity {
                reloadNav(nav) {
                    const qMenu = nav.getQMenu();
                    if (qMenu && qMenu.size > 0) {
                        this.setSubscribersData("qmenu", qMenu);
                        this.notifySubscribers("qmenu");
                    }
                }
                update(app) {
                    if (this.getApp()) {
                        this.getApp().outro();
                    }
                    this.addToData("app", app);
                    this.getAppContainer().replaceByTag(app.getTag());
                    const appInfo = app.getInfo();
                    if (appInfo) {
                        this.setSubscribersData("appInfo", appInfo);
                        this.notifySubscribers("appInfo");
                    }
                    const qMenu = app.getQMenu();
                    if (qMenu && qMenu.size > 0) {
                        this.setSubscribersData("qmenu", qMenu);
                        this.notifySubscribers("qmenu");
                    }
                    app.intro();
                }
                getApp() {
                    return this.get("app");
                }
                setApp(app) {
                    this.addToData("app", app);
                }
                subscribe(type, func) {
                    const s = this.getSubscribers(type);
                    if (s) {
                        s.set(s.size, func);
                        func(this.getSubscribersData(type));
                    }
                }
                getSubscribers(type) {
                    const subs = this.get("subscribers");
                    return subs.get(type);
                }
                setSubscribersData(type, data) {
                    const subsData = this.get("subscribersData");
                    subsData.set(type, data);
                }
                getSubscribersData(type) {
                    const subsData = this.get("subscribersData");
                    return subsData.get(type);
                }
                notifySubscribers(type) {
                    const s = this.getSubscribers(type);
                    const me = this;
                    if (s) {
                        s.forEach((func) => {
                            func(me.getSubscribersData(type));
                        });
                    }
                }
                getAppContainer() {
                    return this.get("appContainer");
                }
                initialize(data) {
                    super.initialize(data);
                    const appCont = new AppContainer(data);
                    this.addToData("appContainer", appCont);
                    this.initSubscribers();
                }
                initSubscribers() {
                    const s = new Map();
                    const sd = new Map();
                    s.set("appInfo", new Map());
                    sd.set("appInfo", new Map());
                    s.set("qmenu", new Map());
                    sd.set("qmenu", new Map());
                    this.addToData("subscribers", s);
                    this.addToData("subscribersData", sd);
                }
            }
            Entity.AppManager = AppManager;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            var Tag = HA.Core.HTML.Tag;
            class AppMenu extends Entity.Entity {
                getInfo() {
                    return this.getTag().getAttributes(["appName", "appIcon"]);
                }
                setController(controller) {
                    return this.addToData("controller", controller);
                }
                getController() {
                    return this.get("controller");
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("cachable", false);
                    this.addToData("tag", new Tag(data));
                    const controllerName = this.get("controllerName");
                    if (controllerName) {
                        const controllerNamespace = this.getControllerNamespace(this.get("controllerNamespace")), cdata = HA.toMap(this.getData());
                        this.setController(HA.createService(controllerNamespace, controllerName, cdata));
                    }
                }
                getControllerNamespace(name) {
                    let n;
                    switch (name) {
                        case "HA.Core.Controller.Navigation":
                            n = HA.Core.Controller.Navigation;
                            break;
                        case "HA.Core.Controller.Menu":
                            n = HA.Core.Controller.Menu;
                            break;
                        case "HA.Core.Controller.Page":
                            n = HA.Core.Controller.Page;
                            break;
                        default:
                            n = HA.Core.Controller.Menu;
                            break;
                    }
                    return n;
                }
            }
            Entity.AppMenu = AppMenu;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Menu;
            (function (Menu) {
                class AppMenu extends HTML.Container {
                    addItems(menuData) {
                        const items = this.getItemsContainer();
                        const me = this;
                        items.clear();
                        menuData.forEach((e) => {
                            const a = new HTML.Anchor(HA.toMap({
                                d: JSON.stringify(e.get("d")),
                                n: () => {
                                    me.hide();
                                },
                                t: e.get("t"),
                            }));
                            a.appendChild(new HTML.MenuItem(e));
                            items.addItem(a);
                        });
                    }
                    getItemsContainer() {
                        return this.get("items");
                    }
                    initialize(data) {
                        super.initialize(data);
                        const itemsContainer = new HTML.List({ tag: new HTML.CFlexContainer({ class: "menus" }) });
                        const ic = new HTML.Div({ classes: ["menupane", "ic"] });
                        ic.appendChild(itemsContainer);
                        this.appendChild(ic);
                        this.addClass("overlay");
                        this.addToData("items", itemsContainer);
                        const me = this;
                        this.onClick(() => {
                            me.hide();
                        });
                    }
                }
                Menu.AppMenu = AppMenu;
            })(Menu = HTML.Menu || (HTML.Menu = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            var AppMenu = HA.Core.HTML.Menu.AppMenu;
            class AppMenuManager extends Entity.Entity {
                show(menuData) {
                    const c = this.getAppContainer();
                    c.addItems(menuData);
                    c.show();
                }
                getAppContainer() {
                    return this.get("appContainer");
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("appContainer", new AppMenu(data));
                }
            }
            Entity.AppMenuManager = AppMenuManager;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            class FSApp extends HA.Core.Entity.App {
            }
            Entity.FSApp = FSApp;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            class HAApp extends Entity.App {
                getQMenu() {
                    if (this.has("qmenu")) {
                        return super.getQMenu();
                    }
                    if (this.hasNavigation()) {
                        return this.getNavigation().getQMenu();
                    }
                }
                hasNavigation() {
                    return this.has("navigation");
                }
                getNavigation() {
                    return this.get("navigation");
                }
            }
            Entity.HAApp = HAApp;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            class HANavigationApp extends Entity.App {
                updateInfo(data) {
                }
                intro() {
                    super.intro();
                    if (this.hasNot("location")) {
                        HA.getDataRepository().saveLocation();
                    }
                }
            }
            Entity.HANavigationApp = HANavigationApp;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            class Menu extends Entity.App {
                clear() {
                    this.getMenu().clear();
                }
                addItem(data) {
                    this.getMenu().addItem(data);
                }
                getMenu() {
                    return this.get("menu");
                }
                initialize(data) {
                    const d = HA.toMap(data);
                    d.set("navigable", false);
                    super.initialize(d);
                    this.addToData("menu", new HA.Core.Controller.HTML.AppMenu(d));
                }
                createTag() {
                    return;
                }
            }
            Entity.Menu = Menu;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            var NavigationContainer = HA.Core.HTML.Container;
            class NavigationAppManager extends Entity.Entity {
                update(app) {
                    if (!app) {
                        return;
                    }
                    this.setApp(app);
                    this.getAppContainer().replaceByTag(app.getTag());
                }
                updateInfo(data) {
                    const app = this.getApp();
                    if (app) {
                        app.updateInfo(data);
                    }
                }
                hide() {
                    this.getAppContainer().hide();
                }
                show() {
                    this.getAppContainer().show();
                }
                getApp() {
                    return this.get("app");
                }
                setApp(app) {
                    this.addToData("app", app);
                }
                getAppContainer() {
                    return this.get("navigationContainer");
                }
                initialize(data) {
                    super.initialize(data);
                    const data2 = HA.toMap(data);
                    data2.delete("navigationContainer");
                    const nav = new NavigationContainer(data2);
                    this.addToData("navigationContainer", nav);
                }
            }
            Entity.NavigationAppManager = NavigationAppManager;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            var Tag = HA.Core.HTML.Tag;
            var Container = HA.Core.HTML.Container;
            class PageBody extends Entity.Entity {
                getAttributes(names) {
                    return this.getTag().getAttributes(names, true);
                }
                showAppMenu(menuData) {
                    this.getAppMenuManager().show(menuData);
                }
                reloadNav(nav) {
                    this.getAppManager().reloadNav(nav);
                    this.getNavigationAppManager().update(nav);
                }
                showApp(app) {
                    this.getNavigationAppManager().show();
                    if (app instanceof Entity.HAApp) {
                        this.getNavigationAppManager().update(app.getNavigation());
                    }
                    else if (app instanceof Entity.FSApp) {
                        this.getNavigationAppManager().hide();
                    }
                    this.getAppManager().update(app);
                }
                getAppManager() {
                    return this.get("ha.appManager");
                }
                getAppMenuManager() {
                    return this.get("ha.appMenuManager");
                }
                getNotification() {
                    return this.getService("ha.service.webpage").notification();
                }
                getTag() {
                    return this.get("horapp");
                }
                getNavigationAppManager() {
                    return this.get("ha.navigationAppManager");
                }
                setNavigationAppManager(navigationAppManager) {
                    return this.addToData("ha.navigationAppManager", navigationAppManager);
                }
                setAppManager(app) {
                    return this.addToData("ha.appManager", app);
                }
                setAppMenuManager(app) {
                    return this.addToData("ha.appMenuManager", app);
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("horapp", new Tag(HA.toMap({ attribute: "horapp" })));
                    this.setNavigationAppManager(new Entity.NavigationAppManager({ attribute: "navigations" }));
                    this.setAppManager(new Entity.AppManager({ attribute: "apps" }));
                    this.setAppMenuManager(new Entity.AppMenuManager({ services: this.get("services"), attribute: "appmenu" }));
                    const notificationContainer = new Container({ className: "hanotification" });
                    this.getNotification().setMainContainer(notificationContainer);
                    this.getTag().insertOnTop(notificationContainer);
                }
            }
            Entity.PageBody = PageBody;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            class PageHead extends Entity.Entity {
                add2Head(data) {
                }
            }
            Entity.PageHead = PageHead;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class FlexContainer extends HTML.Container {
                insertOnTop(element) {
                    super.insertOnTop(element);
                }
                appendChild(element) {
                    super.appendChild(element);
                }
                centered() {
                    this.addClass("fcenter");
                }
                spaceAround() {
                    this.addClass("fsaround");
                }
                appendChildRight(element) {
                    const i = element;
                    i.addClass("fir");
                    super.appendChild(i);
                }
                initialize(data) {
                    super.initialize(data);
                    this.addClass("fc");
                }
            }
            HTML.FlexContainer = FlexContainer;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class CFlexContainer extends HTML.FlexContainer {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("cfc");
                }
            }
            HTML.CFlexContainer = CFlexContainer;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var App;
            (function (App_1) {
                class App extends HTML.Container {
                    addToContainer(tag) {
                        this.getContainer().addItem(tag);
                    }
                    getContainer() {
                        return this.get("--container");
                    }
                    createSelf() {
                        super.createSelf();
                        const container = new HTML.List();
                        this.addToData("--container", container);
                        this.appendChild(container);
                    }
                }
                App_1.App = App;
            })(App = HTML.App || (HTML.App = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var App;
            (function (App) {
                class Search extends App.App {
                    createSelf() {
                        super.createSelf();
                    }
                }
                App.Search = Search;
            })(App = HTML.App || (HTML.App = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            var SearchTag = HA.Core.HTML.App.Search;
            class Search extends Entity.App {
                createTag(data) {
                    this.addToData("tag", new SearchTag(data));
                }
            }
            Entity.Search = Search;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Entity;
        (function (Entity) {
            class User extends Entity.Entity {
                update(data) {
                    this.updateData(data);
                }
                getProfileData() {
                    return this.getData();
                }
            }
            Entity.User = User;
        })(Entity = Core.Entity || (Core.Entity = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Action extends HTML.Tag {
                getTagName() {
                    return "action";
                }
                initialize(data) {
                    super.initialize(data);
                    const f = data.get("f");
                    Function(`"use strict";return ${f}`)();
                }
            }
            HTML.Action = Action;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Anchor extends HTML.Tag {
                getTagName() {
                    return "a";
                }
                getTag() {
                    const tag = this.get("tag");
                    if (tag) {
                        return tag;
                    }
                    if (this instanceof HTML.Tag) {
                        return this;
                    }
                    return null;
                }
                initialize(data) {
                    super.initialize(data);
                    if (data.get("d")) {
                        this.addAttribute("d", data.get("d"));
                        this.addAttribute("t", data.get("t"));
                        this.addAttribute("target", data.get("target"));
                    }
                    if (data.get("href")) {
                        this.addAttribute("href", data.get("href"));
                    }
                    const me = this;
                    this.onClick((event) => {
                        event.stopImmediatePropagation();
                        me.processClick();
                    });
                }
                getType() {
                    return this.getTag().getAttribute("t");
                }
                getTarget() {
                    let target = this.getTag().getAttribute("target");
                    if (!target) {
                        target = this.has("target") ? this.get("target") : "_blank";
                    }
                    return target;
                }
                getCData() {
                    const d = this.getTag().getAttribute("d");
                    try {
                        return HA.toMap(JSON.parse(d));
                    }
                    catch (e) {
                        HA.log2(e);
                        return d;
                    }
                }
                getMData() {
                    const d = this.getTag().getAttribute("d");
                    const result = new Array();
                    try {
                        if (JSON.parse(d)) {
                            const da = JSON.parse(d);
                            if (typeof da === "string") {
                                return da;
                            }
                            da.forEach((e) => {
                                if (typeof e === "string") {
                                    result.push(e);
                                }
                                else {
                                    result.push(HA.toMap(e));
                                }
                            });
                        }
                    }
                    catch (e) {
                        return d;
                    }
                    return result;
                }
                notify() {
                    const n = this.get("n");
                    if (n && n instanceof Function) {
                        n();
                    }
                }
                processClick() {
                    this.notify();
                    const data = this.getCData();
                    switch (this.getType()) {
                        case "form":
                            this.processForm(data);
                            break;
                        case "i":
                            this.processInteractive(data);
                            break;
                        case "showAppMenu":
                            HA.getWebPageService().showAppMenu(this.getMData());
                            break;
                        case "url":
                            const target = this.getTarget();
                            window.open("" + this.getMData(), target);
                            break;
                        case "cpy":
                            this.copy2Clip(this.getMData());
                            break;
                        default:
                            data.set("t", this.getType());
                            HA.getAppService().processAction(data);
                            break;
                    }
                }
                copy2Clip(str) {
                    const el = document.createElement("textarea");
                    el.setAttribute("readonly", "");
                    el.style.position = "absolute";
                    el.style.left = "-9999px";
                    el.value = str;
                    document.body.appendChild(el);
                    const selected = document.getSelection().rangeCount > 0
                        ? document.getSelection().getRangeAt(0)
                        : false;
                    el.select();
                    document.execCommand("copy");
                    document.body.removeChild(el);
                    if (selected) {
                        document.getSelection().removeAllRanges();
                        document.getSelection().addRange(selected);
                    }
                }
                processForm(data) {
                    const me = this;
                    HA.getDataRepository().saveForm(data).then((response) => {
                        const todo = response.get("todo");
                        if (response.get("msg")) {
                            HA.log(response.get("msg"));
                        }
                        if (todo) {
                            switch (todo) {
                                case "reload":
                                    HA.getWebPageService().reloadApp(HA.toMap({ id: response.get("id") }));
                                    break;
                                case "success":
                                    HA.getWebPageService().reloadApp(HA.toMap({ id: response.get("id") }));
                                    break;
                                case "app":
                                    HA.getWebPageService().reloadApp(HA.toMap({ id: response.get("id") }));
                                    break;
                                default:
                                    HA.getAppService().processAction(response);
                                    break;
                            }
                        }
                        else {
                            HA.getAppService().processAction(response);
                        }
                    }).catch((reason) => {
                    });
                }
                updateDom(data) {
                    const doma = data.get("doma");
                    switch (doma) {
                        case "repl":
                            const t = this.findById(data.get("eid"), true);
                            t.clear();
                            t.appendChild(new HTML.Tag(data.get("c")));
                            break;
                        default:
                    }
                }
                processInteractive(data) {
                    const me = this;
                    HA.getDataRepository().fetchData(data).then((response) => {
                        me.processAction(response);
                    }).catch((reason) => {
                        HA.ptime(["eRRRR", reason]);
                    });
                }
                processAction(data) {
                    const todo = data.get("todo");
                    if (data.get("msg")) {
                        HA.log(data.get("msg"));
                    }
                    if (todo) {
                        switch (todo) {
                            case "reload":
                                HA.getWebPageService().reloadApp(HA.toMap(data.get("d")));
                                break;
                            case "success":
                            case "app":
                                HA.getWebPageService().reloadApp(HA.toMap(data.get("d")));
                                break;
                            case "url":
                                HA.timeout(() => {
                                    window.open(data.get("url"), data.get("target"));
                                }, 200);
                                break;
                            case "dom":
                                this.updateDom(data);
                                break;
                            case "bulk":
                            case "steps":
                                this.processBulkAction(data.get("steps"));
                                break;
                            default:
                                HA.getAppService().processAction(data);
                                break;
                        }
                    }
                    else {
                        HA.getAppService().processAction(data);
                    }
                }
                processBulkAction(data) {
                    for (const item of data) {
                        this.processAction(HA.toMap(item));
                    }
                }
            }
            HTML.Anchor = Anchor;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class B extends HTML.Div {
                getTagName() {
                    return "b";
                }
            }
            HTML.B = B;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Cite extends HTML.CFlexContainer {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("cite");
                    const title = this.get("title");
                    const img = this.get("img");
                    if (img) {
                        this.appendChild(new HTML.UImg(img));
                    }
                    else if (title) {
                        const t = new HTML.Div({ class: "ctitle", txt: title });
                        this.appendChild(t);
                    }
                    const body = this.get("b");
                    if (body) {
                        const b = new HTML.Div({ class: "cbody" });
                        b.appendChild(new HTML.Tag(HA.toMap(body)));
                        this.appendChild(b);
                    }
                }
            }
            HTML.Cite = Cite;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Code extends HTML.CFlexContainer {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("cite");
                    const title = this.get("title");
                    const img = this.get("img");
                    if (img) {
                        this.appendChild(new HTML.UImg(img));
                    }
                    else if (title) {
                        const t = new HTML.Div({ class: "ctitle", txt: title });
                        this.appendChild(t);
                    }
                    const body = this.get("b");
                    if (body) {
                        const b = new HTML.Tag({ html: "<code></code>", class: "cbody" });
                        if (this.get("raw")) {
                            b.setText(body);
                        }
                        else {
                            b.appendChild(new HTML.Tag(HA.toMap(body)));
                        }
                        this.appendChild(b);
                    }
                }
            }
            HTML.Code = Code;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Span extends HTML.Tag {
                getTagName() {
                    return "span";
                }
            }
            HTML.Span = Span;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Dynamic extends HTML.Div {
                static guessContentType(data) {
                    if (!(data instanceof Map) || !data.get("c")) {
                        return null;
                    }
                    const c = data.get("c");
                    if (!(c instanceof Map) || !(typeof (c.get("0")) === "object")) {
                        return null;
                    }
                    const first = HA.toMap(c.get("0"));
                    return first.get("t");
                }
                getTagName() {
                    return this.get("_tname");
                }
                initialize(data) {
                    const ctype = Dynamic.guessContentType(data);
                    if (!ctype) {
                        if (data instanceof Map) {
                            data.set("_tname", "span");
                        }
                        super.initialize(data);
                        this.addClass("tf");
                        return;
                    }
                    data.set("_tname", "div");
                    super.initialize(data);
                }
            }
            HTML.Dynamic = Dynamic;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Heading extends HTML.Tag {
                getTagName() {
                    return this.get('t');
                }
            }
            HTML.Heading = Heading;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service_1) {
            class Service extends HA.HAObject {
            }
            Service_1.Service = Service;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var App;
            (function (App) {
                class Menu extends App.App {
                    clear() {
                        this.getMenus().clear();
                        return this;
                    }
                    addItem(data) {
                        this.getMenus().addItem(data);
                    }
                    createSelf() {
                        super.createSelf();
                        this.addClass("qmenu");
                        this.addToContainer(new HTML.TextField({ class: "label", text: document.createTextNode("Menu") }));
                        const data = HA.toMap(this.getData());
                        data.delete("element");
                        const items = new HTML.MenuPane(data);
                        this.addToContainer(items);
                        this.addToData("items", items);
                    }
                    initialize(data) {
                        super.initialize(data);
                    }
                    getMenus() {
                        return this.get("items");
                    }
                }
                App.Menu = Menu;
            })(App = HTML.App || (HTML.App = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var HTML;
            (function (HTML) {
                var MenuTag = HA.Core.HTML.App.Menu;
                class AppMenu extends Controller.Controller {
                    clear() {
                        this.getTag().clear();
                    }
                    addItem(data) {
                        this.getTag().addItem(data);
                    }
                    createTag(data) {
                        this.addToData("tag", new MenuTag(data));
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.createTag(data);
                    }
                }
                HTML.AppMenu = AppMenu;
            })(HTML = Controller.HTML || (Controller.HTML = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Service;
            (function (Service) {
                var MenuTag = HA.Core.Controller.HTML.AppMenu;
                var HAService = HA.Core.Service.Service;
                class HtmlService extends HAService {
                    static uuidv4() {
                        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
                            const r = Math.random() * 16 | 0;
                            const v = c === "x" ? r : (r & 0x3 | 0x8);
                            return v.toString(16);
                        });
                    }
                    static createHtml(data, service) {
                        const t = data.get("t") || "";
                        switch (t) {
                            case "m":
                                data.set("services", service);
                                return HtmlService.createMenuApp(data);
                            case "pa-rlp":
                                return new HTML.ResultListPage(data);
                            case "pa":
                                return new HTML.Page(data);
                            default:
                                return HtmlService.createContainer(data);
                        }
                    }
                    static createFormItem(data) {
                        const t = data.get("ft") || "";
                        switch (t) {
                            case "mslct":
                            case "slct":
                                return new HA.Core.HTML.Form.Select(data);
                            case "txt":
                                data.set("textarea", 1);
                            case "txtl":
                                return new HA.Core.HTML.Form.Text(data);
                            case "mtxt":
                                return new HA.Core.HTML.Form.MultiText(data);
                            case "fs":
                                return new HA.Core.HTML.Form.HAFile(data);
                            case "mm":
                                return new HA.Core.HTML.Form.MultiMedia(data);
                            case "btn":
                                return new HA.Core.HTML.Form.Button(data);
                            default:
                                break;
                        }
                    }
                    static createByType(data, main, translation) {
                        const t = data.get("t");
                        let tag = null;
                        try {
                            switch (t) {
                                case "t1":
                                case "t2":
                                case "t3":
                                case "t4":
                                    tag = new HTML.Span(data);
                                    tag.addClass(t);
                                    break;
                                case "tf":
                                    tag = new HTML.Span(data);
                                    tag.addClass("tf");
                                    break;
                                case "h1":
                                case "h2":
                                case "h3":
                                case "h4":
                                    tag = new HTML.Heading(data);
                                    break;
                                case "img":
                                case "media":
                                    const src = main.translate(data.get("src"), translation);
                                    if (src) {
                                        data.set("src", src);
                                    }
                                    main.appendChild(new HTML.Img(data));
                                    break;
                                case "cfc":
                                    main.appendChild(new HTML.CFlexContainer(data));
                                    break;
                                case "fc":
                                    main.appendChild(new HTML.FlexContainer(data));
                                    break;
                                case "div":
                                    main.appendChild(new HTML.Div(data));
                                    break;
                                case "a":
                                    main.appendChild(new HTML.Anchor(data));
                                    break;
                                case "ai":
                                    return HA.getAppService().processAction(data.get("d"));
                                case "span":
                                    main.appendChild(new HTML.Span(data));
                                    break;
                                case "p":
                                    main.appendChild(new HTML.P(data));
                                    break;
                                case "pn":
                                    main.appendChild(new HTML.Pane(data));
                                    break;
                                case "ref":
                                    main.appendChild(new HTML.Reference(data));
                                    break;
                                case "formi":
                                    main.appendChild(HtmlService.createFormItem(data));
                                    break;
                                case "form":
                                    const form = new HA.Core.HTML.Form.Form(data);
                                    form.setAttribute("i", 1);
                                    const d2 = new Map();
                                    d2.set("tag", form);
                                    new HA.Core.Controller.Form.FormController(d2);
                                    main.appendChild(form);
                                    break;
                                case "inputp":
                                case "inpute":
                                case "input":
                                    tag = new HTML.Form.Input(data);
                                    if (t === "inputp") {
                                        tag.setAttribute("type", "password");
                                    }
                                    else if (t === "inpute") {
                                        tag.setAttribute("type", "email");
                                    }
                                    main.appendChild(tag);
                                    break;
                                case "textarea":
                                    main.appendChild(new HA.Core.HTML.Form.Textarea(data));
                                    break;
                                case "submit":
                                    tag = new HTML.Form.Input(data);
                                    tag.setAttribute("type", "submit");
                                    main.appendChild(tag);
                                    break;
                                case "b":
                                    main.appendChild(new HTML.B(data));
                                    break;
                                case "i":
                                    main.appendChild(new HTML.I(data));
                                    break;
                                case "t":
                                    main.appendChild(new HTML.Tag(data));
                                    break;
                                case "nav":
                                    main.appendChild(new HA.Core.HTML.Navigation.Navigation(data));
                                    break;
                                case "dyn":
                                    main.appendChild(new HTML.Dynamic(data));
                                    break;
                                case "mod":
                                    main.appendChild(new HTML.Module(data));
                                    break;
                                case "cite":
                                    main.appendChild(new HTML.Cite(data));
                                    break;
                                case "section":
                                    main.appendChild(new HTML.Section(data));
                                    break;
                                case "table":
                                    main.appendChild(new HTML.Table(data));
                                    break;
                                case "l":
                                case "list":
                                    main.appendChild(new HTML.List(data));
                                    break;
                                case "uimg":
                                    main.appendChild(new HTML.UImg(data));
                                    break;
                                case "win":
                                    main.appendChild(new HTML.Window(data));
                                    break;
                                case "pa":
                                    main.appendChild(new HTML.Page(data));
                                    break;
                                case "carousel":
                                    main.appendChild(new HTML.Carousel(data));
                                    break;
                                case "slider":
                                    main.appendChild(new HTML.Slider(data));
                                    break;
                                case "pa-rlp":
                                    main.appendChild(new HTML.ResultListPage(data));
                                    break;
                                case "rl":
                                    main.appendChild(new HTML.Div(data));
                                    break;
                                case "mp":
                                    main.appendChild(new HA.Core.HTML.MenuPane(data));
                                    break;
                                case "map":
                                    main.appendChild(new HA.Core.HTML.GMap(data));
                                    break;
                                case "gal":
                                    main.appendChild(new HA.Core.HTML.Media.Gallery(data));
                                    break;
                                case "youtube":
                                    tag = new HTML.Div();
                                    tag.appendChild(new HTML.Youtube(data));
                                    tag.addClass("youtubeContainer");
                                    main.appendChild(tag);
                                    break;
                                case "twitter":
                                    tag = new HTML.Div();
                                    tag.appendChild(new HTML.Twitter(data));
                                    tag.addClass("twitterContainer");
                                    main.appendChild(tag);
                                    break;
                                case "code":
                                    main.appendChild(new HTML.Code(data));
                                    break;
                                case "action":
                                    new HTML.Action(data);
                                    break;
                                default:
                                    break;
                            }
                        }
                        catch (e) {
                            console.error(e);
                            HA.log2(data);
                        }
                        if (tag) {
                            main.appendChild(tag);
                        }
                    }
                    static createMenuApp(data) {
                        return new MenuTag(data);
                    }
                    static createContainer(data) {
                        return new HTML.Container(data);
                    }
                }
                Service.HtmlService = HtmlService;
            })(Service = HTML.Service || (HTML.Service = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class I extends HTML.Div {
                getTagName() {
                    return "i";
                }
            }
            HTML.I = I;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Iframe extends HTML.Tag {
                initialize(data) {
                    data.set("html", "<iframe width=\”560\″ height=\”315\″ src=\"" + data.get("src") + "\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>");
                    super.initialize(data);
                }
                getTagName() {
                    return "iframe";
                }
            }
            HTML.Iframe = Iframe;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var HtmlService = HA.Core.HTML.Service.HtmlService;
            class Img extends HTML.Tag {
                updateSrc(src) {
                    this.addToData("src", src);
                    this.addAttribute("src", src);
                }
                initialize(data) {
                    if (typeof data === "string") {
                        data = HA.toMap({ src: data });
                    }
                    if (data.get("src")) {
                        data.set("src", this.translate(data.get("src")));
                        data.set("_tn", "img");
                        super.initialize(data);
                        this.addAttribute("data-id", HtmlService.uuidv4());
                        this.addAttribute("alt", this.translate(this.get("alt")) || "Image");
                        if (this.get("h")) {
                            this.addAttribute("height", this.get("h"));
                        }
                        if (this.get("w")) {
                            this.addAttribute("width", this.get("w"));
                        }
                        if (this.has("load")) {
                            this.addAttribute("src", this.get("src"));
                        }
                        else {
                            this.addAttribute("data-src", this.get("src"));
                            this.addAttribute("loading", "lazy");
                            HA.lazyloadImage(this.getElement());
                        }
                    }
                    else if (data.get("f")) {
                        const file = data.get("f");
                        const me = this;
                        super.initialize(HTML.Tag.createElement("img"));
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            me.setAttribute("src", reader.result);
                        };
                        reader.readAsDataURL(file);
                    }
                    else {
                        super.initialize(data);
                    }
                }
            }
            HTML.Img = Img;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Module extends HTML.Div {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("mod");
                    this.setActive(true);
                    this.setId(HA.Core.Entity.Entity.genId());
                    this.loadData();
                    if (this.has("upinternal")) {
                        const interval = setInterval(() => {
                            this.loadData();
                        }, this.get("upinternal"));
                        const me = this;
                        const [appId, subscriptionId] = HA.getWebPageService().subscribeToAppInfo((info) => {
                            if (info.get("s") === -1) {
                                clearInterval(interval);
                                HA.getWebPageService().unsubscribeToAppInfo(subscriptionId);
                                return;
                            }
                            me.setActive(appId === info.get("id"));
                        });
                    }
                }
                loadData() {
                    if (!this.isActive()) {
                        return;
                    }
                    const me = this;
                    HA.getDataRepository().fetchData(this.get("d")).then((response) => {
                        const app = HA.toMap(response.get("app"));
                        if (!app) {
                            return;
                        }
                        const md = HA.toMap(app.get("mod"));
                        const d = HA.toMap(md.get("d"));
                        d.set("trans", md.get("trans"));
                        if (md.has("class")) {
                            this.addClass(md.get("class"));
                        }
                        else if (md.has("classes")) {
                            this.addClasses(md.get("classes"));
                        }
                        me.clear();
                        me.appendChild(new HTML.Tag(d));
                        this.initAnchors(this);
                    });
                }
                initAnchors(tag) {
                    tag = tag || this.getTag();
                    const anchors = tag.fetchByTagName("a");
                    anchors.forEach((anchor) => {
                        if (anchor.getAttribute("i")) {
                            return;
                        }
                        anchor.setAttribute("i", "1");
                        const data = new Map();
                        data.set("tag", anchor);
                        data.set("services", HA.getService4App());
                        const a = new HTML.Anchor(data);
                    });
                }
                isActive() {
                    return this.get("isActive");
                }
                setActive(active) {
                    this.addToData("isActive", active);
                }
            }
            HTML.Module = Module;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class P extends HTML.Tag {
                getTagName() {
                    return "p";
                }
            }
            HTML.P = P;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Box extends HTML.Container {
                createSelf() {
                    super.createSelf();
                    this.addClass("box");
                }
            }
            HTML.Box = Box;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Pane extends HTML.Box {
                createByType(data, main) {
                    const t = data.get("t");
                    switch (t) {
                        case "pn":
                            main.appendChild(new Pane(data));
                            break;
                        case "mp":
                            main.appendChild(new HA.Core.HTML.Panel.MediaPane(data));
                            break;
                        default:
                            super.createByType(data, main);
                            return;
                    }
                }
                createSelf() {
                    super.createSelf();
                    this.addClass("pane");
                }
            }
            HTML.Pane = Pane;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Page extends HTML.Container {
                static createNewByType(data, main) {
                    return (new Page()).createByType(data, main);
                }
                createByType(data, main) {
                    const t = data.get("t");
                    let tag = null;
                    switch (t) {
                        case "m":
                            main.appendChild(new HTML.Div(data));
                            return;
                        case "pa-a":
                            tag = new HTML.ArticlePage(data);
                            break;
                        case "pa-s":
                            tag = new Page(data);
                            break;
                        case "pa-m":
                            tag = new HTML.ResultListPage(data);
                            break;
                        case "pa-rlp":
                            tag = new HTML.ResultListPage(data);
                            break;
                        case "s":
                            tag = new HA.Core.HTML.TBox.Section({ d: data.get("d") });
                            break;
                        case "tb":
                            tag = new HTML.TextBox({ tdata: data.get("d") });
                            break;
                        default:
                            super.createByType(data, main);
                            break;
                    }
                    if (tag) {
                        main.appendChild(tag);
                    }
                }
                initialize(data) {
                    super.initialize(data);
                    this.addAttribute("tt", "pa");
                    this.addClass("pages");
                }
                createSelf() {
                    super.createSelf();
                    const c = new HTML.CFlexContainer({ class: "pa-cont" });
                    const me = this;
                    const tdata = this.get("d");
                    const trans = this.get("trans");
                    if (tdata) {
                        try {
                            this.replaceValues(tdata);
                            tdata.forEach((item) => {
                                if (!item) {
                                    return;
                                }
                                const nitem = HA.toMap(item);
                                if (trans) {
                                    nitem.set("trans", trans);
                                }
                                me.createByType(nitem, c);
                            });
                        }
                        catch (e) {
                            throw e;
                        }
                    }
                    this.appendChild(c);
                }
            }
            HTML.Page = Page;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Reference extends HTML.Tag {
                createSelf() {
                    const c = new HTML.Tag({
                        c: [{
                                c: [
                                    {
                                        class: "see",
                                        t: "span",
                                        c: [this.get("label")],
                                    },
                                    {
                                        attributes: [
                                            {
                                                n: "t",
                                                v: "showApp",
                                            },
                                            {
                                                n: "d",
                                                v: this.translate(this.get("a")),
                                            },
                                        ],
                                        t: "a",
                                        c: [this.get("v")],
                                    }
                                ],
                                t: "fc",
                            }],
                        class: "ref",
                    });
                    this.setElement(c.getElement());
                }
            }
            HTML.Reference = Reference;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Section extends HTML.Div {
                getTagName() {
                    return "section";
                }
            }
            HTML.Section = Section;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class SuggestionItemTag extends HTML.Tag {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("sit");
                }
            }
            HTML.SuggestionItemTag = SuggestionItemTag;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Table extends HTML.Div {
                getTagName() {
                    return "table";
                }
                initialize(data) {
                    super.initialize(data);
                    this.addClass("table");
                }
                createSelf() {
                    super.createSelf();
                    const h = this.get("h");
                    const b = this.get("b");
                    const element = this.getElement();
                    if (h) {
                        const trh = element.createTHead();
                        const hr = trh.insertRow(0);
                        h.forEach((i) => {
                            if (true) {
                                const c = document.createElement("th");
                                c.appendChild(document.createTextNode(i));
                                hr.appendChild(c);
                            }
                            else {
                                const cell = hr.insertCell(0);
                                cell.innerHTML = i;
                            }
                        });
                    }
                    if (b) {
                        const trb = element.createTBody();
                        b.forEach((r) => {
                            const br = trb.insertRow(-1);
                            r.forEach((i) => {
                                const cell = br.insertCell(-1);
                                if (i instanceof Object) {
                                    const i2 = new HTML.Tag(i);
                                    cell.appendChild(i2.getElement());
                                }
                                else {
                                    cell.innerHTML = i;
                                }
                            });
                            this.appendChild(trb);
                        });
                    }
                }
            }
            HTML.Table = Table;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Service;
            (function (Service) {
                var HAService = HA.Core.Service.Service;
                class Template extends HAService {
                }
            })(Service = HTML.Service || (HTML.Service = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class TextField extends HTML.Div {
                initialize(data) {
                    if (typeof data == "string") {
                        data = HA.toMap({ text: document.createTextNode(data) });
                    }
                    super.initialize(data);
                    this.addClass("tf");
                    this.appendChild(this.get("text"));
                }
            }
            HTML.TextField = TextField;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Twitter extends HTML.Tag {
                getTagName() {
                    return "twitter";
                }
            }
            HTML.Twitter = Twitter;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Youtube extends HTML.Iframe {
                initialize(data) {
                    data.set("html", "<iframe class=\"youtube\" src=\"https://www.youtube.com/embed/" + data.get("id") + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>");
                    super.initialize(data);
                }
            }
            HTML.Youtube = Youtube;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var HAList;
            (function (HAList) {
                class EntryItem extends HTML.Pane {
                    getModel() {
                        const model = this.get("model");
                        return this.replaceValues(model);
                    }
                    createSelf() {
                        super.createSelf();
                        const model = this.getModel();
                        try {
                            this.createByType(model, this);
                        }
                        catch (e) {
                            HA.ptime(e);
                            HA.log("ooups!");
                            throw e;
                        }
                        this.addClass("ei");
                    }
                }
                HAList.EntryItem = EntryItem;
            })(HAList = HTML.HAList || (HTML.HAList = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var EntryItem = HA.Core.HTML.HAList.EntryItem;
            class List extends HTML.Container {
                setModel(model) {
                    if (!(model instanceof Map)) {
                        model = HA.toMap(model);
                    }
                    if (!model.get("list")) {
                        model = HA.toMap({ list: HA.toMap({ default: model }) });
                    }
                    if (!(model.get("list") instanceof Map)) {
                        model.set("list", HA.toMap(model.get("list")));
                    }
                    this.addToData("model", HA.toMap(model));
                    this.addToData("mod", "m");
                    if (!this.has("entryClass")) {
                        this.addToData("entryClass", EntryItem);
                    }
                }
                setItemClick(func) {
                    this.addToData("itemClick", func);
                }
                addAllByModel(data) {
                    const me = this;
                    data.forEach((d) => {
                        me.addByModel(d);
                    });
                }
                addByModel(data) {
                    if (this.has("nowrap")) {
                        const m = HA.toMap(this.getModel(data.get("_model")));
                        m.set("trans", data.get("trans"));
                        this.addItem(new HTML.Tag(m));
                        return;
                    }
                    data.set("model", HA.toMap(this.getModel(data.get("_model"))));
                    this.addItem(data);
                }
                getModel(name) {
                    const m = this.get("model");
                    if (!m.has("list")) {
                        return m;
                    }
                    const list = m.get("list");
                    if (name && list.get(name)) {
                        return list.get(name);
                    }
                    return list.get("default");
                }
                replaceItems(items) {
                    this.clear();
                    this.addToData("items", new Map());
                    const me = this;
                    items.forEach((e) => {
                        me.addItem(e);
                    });
                }
                hasValue(v) {
                    let r = false;
                    this.getItems().forEach((i) => {
                        if (i.getValue() === v) {
                            r = true;
                            return;
                        }
                    });
                    return r;
                }
                getFirst() {
                    const items = this.getItems();
                    let i2;
                    items.forEach((i, id) => {
                        if (!i2) {
                            i2 = i;
                            return;
                        }
                    });
                    return i2;
                }
                removeFirst() {
                    const item = this.getFirst();
                    if (item) {
                        const el = this.getElement();
                        if (el.firstChild) {
                            el.removeChild(el.firstChild);
                        }
                        this.getItems().delete(item.getId());
                        return item;
                    }
                    return null;
                }
                getValues() {
                    const r = [];
                    this.getItems().forEach((i) => {
                        r.push(i.getValue());
                    });
                    return r;
                }
                addItems(items, noAppend) {
                    const me = this;
                    items.forEach((data) => {
                        me.addItem(data, noAppend);
                    });
                }
                addItem(item, noAppend) {
                    const entry = this.toEntry(item);
                    this.getItems().set(entry.getId(), entry);
                    if (!noAppend) {
                        this.appendChild(entry);
                    }
                }
                getItems() {
                    if (this.hasNot("items")) {
                        this.addToData("items", new Map());
                    }
                    return this.get("items");
                }
                initialize(data) {
                    super.initialize(data);
                    const me = this;
                    const c = this.getChildren();
                    const itemTagClass = this.get("itemTagClass");
                    if (this.has("m")) {
                        this.setModel(this.translate(this.get("m")));
                    }
                    c.forEach((tag) => {
                        if (itemTagClass) {
                            me.addItem(new itemTagClass(tag), true);
                        }
                        else {
                            me.addItem(tag, true);
                        }
                    });
                    if (this.has("d")) {
                        const items = HA.toMap(this.translate(this.get("d")));
                        if (items) {
                            items.forEach((i) => {
                                me.addByModel(HA.toMap(i));
                            });
                        }
                    }
                }
                toEntry(tag) {
                    if (this.has("entryClass") && !(tag instanceof this.get("entryClass"))) {
                        const c = this.get("entryClass");
                        const tag2 = new c(tag);
                        if (this.has("itemClick")) {
                            const t2 = HA.toMap(tag.get("trans")).get("cd");
                            tag2.onClick(() => {
                                this.get("itemClick")(t2);
                            });
                        }
                        tag = tag2;
                    }
                    if (!tag.getId()) {
                        tag.setId(Math.random() * 1000000);
                    }
                    return tag;
                }
            }
            HTML.List = List;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Notification;
        (function (Notification) {
            var CFlexContainer = HA.Core.HTML.CFlexContainer;
            var List = HA.Core.HTML.List;
            class HANotification extends HA.Core.Service.Service {
                watch(data) {
                    HA.getDataRepository().fetchData(data).then((rData) => {
                        this.processAction(rData);
                    });
                }
                info(msg) {
                    this.show(this.createInfo(msg));
                }
                log(msg) {
                    if (!(msg instanceof Map) && msg instanceof Object) {
                        this._log(HA.toMap(msg));
                        return;
                    }
                    this._log(msg);
                }
                _log(msg) {
                    this.show(this.createLog(msg));
                }
                isDebug() {
                    return this.get("debug") === true;
                }
                activateDebugMode() {
                    this.addToData("debug", true);
                    HA.log2("Debug mode activated");
                }
                deactivateDebugMode() {
                    this.addToData("debug", false);
                }
                setMainContainer(container) {
                    container.appendChild(this.getNotificationContainer());
                    container.hide("fixed");
                    this.addToData("mcontainer", container);
                }
                show(tag) {
                    if (this.isBusy()) {
                        tag.hide();
                    }
                    else {
                        this.setBusy();
                        tag.show();
                    }
                    this.getNotificationContainer().addItem(tag);
                }
                showNext() {
                    const first = this.getNotificationContainer().removeFirst();
                    first.hide();
                    const next = this.getNotificationContainer().getFirst();
                    if (next) {
                        next.show();
                        return;
                    }
                    this.setNotBusy();
                }
                setNotBusy() {
                    this.addToData("busy", false);
                    this.getMainContainer().hide("fixed");
                }
                setBusy() {
                    this.addToData("busy", true);
                    this.getMainContainer().show();
                }
                isBusy() {
                    return this.get("busy") === true;
                }
                createInfo(data) {
                    const me = this;
                    let d = data;
                    if (!(data instanceof Map)) {
                        d = HA.toMap({
                            end: () => {
                                me.showNext();
                            },
                            m: data,
                        });
                    }
                    else {
                        d.set("end", () => {
                            me.showNext();
                        });
                    }
                    const info = new Notification.NotificationEntry(d);
                    info.addClass("dlogcontainer");
                    return info;
                }
                createLog(data) {
                    const me = this;
                    let d = data;
                    if (!(data instanceof Map)) {
                        d = HA.toMap({
                            m: data,
                            end: () => {
                                me.showNext();
                            },
                        });
                    }
                    else {
                        d.set("end", () => {
                            me.showNext();
                        });
                    }
                    const log = new Notification.NotificationEntry(d);
                    log.addClass("dlogcontainer");
                    return log;
                }
                initialize(data) {
                    super.initialize(data);
                    HA.setNotification(this);
                    this.createNotificationContainer();
                }
                processAction(data) {
                    switch (data.get("t")) {
                        case "msg":
                            this.info(data);
                            break;
                        case "bulk":
                        case "steps":
                            this.processBulkAction(data.get("steps"));
                            break;
                        case "idle":
                            HA.timeout(() => {
                                this.processAction(HA.toMap(data.get("data")));
                            }, data.get("d"));
                            break;
                        case "watch":
                            this.watch(data);
                            break;
                        default:
                            HA.getAppService().processAction(data);
                            break;
                    }
                }
                processBulkAction(data) {
                    for (const item of data) {
                        this.processAction(HA.toMap(item));
                    }
                }
                createNotificationContainer() {
                    this.addToData("_notifs", new List({ tag: new CFlexContainer({ className: "c100" }) }));
                }
                getNotificationContainer() {
                    return this.get("_notifs");
                }
                getMainContainer() {
                    return this.get("mcontainer");
                }
            }
            Notification.HANotification = HANotification;
        })(Notification = Core.Notification || (Core.Notification = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Notification;
        (function (Notification) {
            var Tag = HA.Core.HTML.Tag;
            var Span = HA.Core.HTML.Span;
            var Div = HA.Core.HTML.Div;
            class NotificationEntry extends Tag {
                show() {
                    super.show();
                    this.addToData("interval", HA.timeout(() => {
                        this.end();
                    }, this.get("d") || 3000));
                    this.onClick(() => {
                        this.end();
                    });
                }
                hide() {
                    super.hide("table");
                }
                pause() {
                }
                end() {
                    clearTimeout(this.get("interval"));
                    this.get("end")();
                }
                createSelf() {
                    const item = new Div();
                    item.setAttribute("data-nosnippet", '');
                    const m = this.get("m");
                    let mtext = "";
                    if (m instanceof Map || m instanceof Array) {
                        m.forEach((e) => {
                            mtext += e;
                        });
                    }
                    else {
                        mtext = m;
                    }
                    item.appendChild(new Span(mtext));
                    this.setElement(item.getElement(true));
                }
                initialize(data) {
                    super.initialize(data);
                    const a = this.get("a");
                    if (a) {
                        this.onClick(() => {
                            HA.getAppService().processAction(HA.toMap(a));
                        });
                    }
                }
            }
            Notification.NotificationEntry = NotificationEntry;
        })(Notification = Core.Notification || (Core.Notification = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Repository;
        (function (Repository_1) {
            class Repository extends HA.HAObject {
                cache(data, entity) {
                    this.getCache().set(data.get("id"), entity);
                }
                delFromCache(id) {
                    return this.getCache().delete(id);
                }
                clearCache() {
                    this.addToData("cache", HA.toMap([]));
                }
                getFromCache(data) {
                    return this.getCache().get(data.get("id"));
                }
                isCached(data) {
                    var _a;
                    const id = (_a = data.get("id")) !== null && _a !== void 0 ? _a : null;
                    if (!id)
                        return false;
                    return this.getCache().has(id);
                }
                getCache() {
                    return this.get("cache");
                }
                request(data) {
                    return this.getRouter().post(data);
                }
                requestGet(data) {
                    return this.getRouter().doGet(data);
                }
                getRouter() {
                    if (this.hasNot("router")) {
                        this.addToData("router", new HA.Core.Route.HARouter());
                    }
                    return this.get("router");
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("cache", HA.toMap([]));
                }
            }
            Repository_1.Repository = Repository;
        })(Repository = Core.Repository || (Core.Repository = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Repository;
        (function (Repository) {
            var AppEntity = HA.Core.Entity.App;
            var HAApp = HA.Core.Entity.HAApp;
            var HANavigationApp = HA.Core.Entity.HANavigationApp;
            class App extends Repository.Repository {
                findNavigationById(data) {
                    return this.findById(data, true);
                }
                findById(data, isNavigation) {
                    if (this.isCached(data)) {
                        return Promise.resolve(this.getFromCache(data));
                    }
                    if (data.size < 1) {
                        return Promise.reject("no app id.");
                    }
                    const me = this;
                    const reqData = [];
                    data.forEach((v, n) => {
                        reqData[n] = v;
                    });
                    return this.request(HA.toMap({ url: "/ha/app", data: reqData }))
                        .then((response) => {
                        const elementData = HA.toMap(response.get("app"));
                        let app = null;
                        if (elementData && response.get("success") === true) {
                            let aid = elementData.get("id");
                            if (!aid) {
                                aid = data.get("id");
                            }
                            else {
                                data.set("id", aid);
                            }
                            if (data.has("_id") && !elementData.has("_id")) {
                                elementData.set("_id", data.get("_id"));
                            }
                            const appData = HA.toMap({
                                id: aid,
                                services: me.getAppServices(),
                            }, elementData);
                            if (appData.has("navigationData")) {
                                return me.findById(HA.toMap(appData.get("navigationData")), true).then((navApp) => {
                                    appData.set("navigation", navApp);
                                    app = new HAApp(appData);
                                    me.cache(data, app);
                                    return app;
                                });
                            }
                            else {
                                if (data.has("_isModal") || appData.has("_isModal")) {
                                    app = new HA.Core.Entity.FSApp(appData);
                                }
                                else {
                                    app = isNavigation ? new HANavigationApp(appData) : new AppEntity(appData);
                                }
                                me.cache(data, app);
                                return app;
                            }
                        }
                        else {
                            return Promise.reject(response);
                        }
                    }).catch((response) => {
                        return Promise.reject(response);
                    });
                }
                createApp(data, elementData, isNavigation) {
                    let app;
                    let aid = elementData.get("id");
                    if (!aid) {
                        aid = data.get("id");
                    }
                    else {
                        data.set("id", aid);
                    }
                    if (data.has("_id") && !elementData.has("_id")) {
                        elementData.set("_id", data.get("_id"));
                    }
                    const appData = HA.toMap({
                        id: aid,
                        services: this.getAppServices(),
                    }, elementData);
                    if (data.has("_isModal") || appData.has("_isModal")) {
                        app = new HA.Core.Entity.FSApp(appData);
                    }
                    else {
                        app = isNavigation ? new HANavigationApp(appData) : new AppEntity(appData);
                    }
                    this.cache(data, app);
                    return app;
                }
                remove(id) {
                    this.delFromCache(id);
                }
                getAppServices() {
                    return {
                        "ha.service.appManager": this.get("ha.service.appManager"),
                        "ha.service.user": this.get("ha.service.user"),
                        "ha.service.webpage": this.get("ha.service.webpage"),
                    };
                }
                createElement(data) {
                    const tempParent = document.createElement("div");
                    tempParent.innerHTML = data.get("html");
                    return tempParent.firstElementChild;
                }
                queryDB(data) {
                    const memoire = this.getMemoire();
                    if (memoire && memoire.has(data.get("id"))) {
                        return HA.toMap(memoire.get(data.get("id")));
                    }
                    else {
                        const appData = this.request(HA.toMap({
                            cb: (response) => {
                                data.get("cb")(response.toMap());
                            },
                            data: {
                                id: data.get("id"),
                            },
                            url: "/ha/app",
                        }));
                    }
                }
                getMemoire() {
                    return this.get("memoire");
                }
                initDB() {
                    this.addToData("memoire", new Map());
                }
            }
            Repository.App = App;
        })(Repository = Core.Repository || (Core.Repository = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Repository;
        (function (Repository) {
            class Data extends Repository.Repository {
                saveForm(d) {
                    return this.request(HA.toMap({
                        data: d,
                        url: "/ha/form",
                    }));
                }
                fetchData(d) {
                    return this.request(HA.toMap({
                        data: d,
                        url: "/ha/app",
                    }));
                }
                saveData(d) {
                    return this.request(HA.toMap({
                        data: d,
                        url: "/ha/app",
                    }));
                }
                saveLocation() {
                    const me = this;
                    this.requestGet(HA.toMap({ url: "https://ipinfo.io/json" })).then((response) => {
                        response.set("id", "geoip");
                        me.saveData(response);
                    });
                }
            }
            Repository.Data = Data;
        })(Repository = Core.Repository || (Core.Repository = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Repository;
        (function (Repository) {
            class User extends Repository.Repository {
                getUserProfile(data) {
                    return this.request(HA.toMap({
                        url: "/user/profile",
                        data: [],
                    }));
                }
                findByCredencial(data) {
                    return this.request(HA.toMap({
                        url: "/user/login",
                        data,
                    }));
                }
                getUser() {
                    return new HA.Core.Entity.User({ pic: "/media/img/richo", name: "Richo", id: "AXCVFG" });
                }
            }
            Repository.User = User;
        })(Repository = Core.Repository || (Core.Repository = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Route;
        (function (Route) {
            class HARouter extends HA.HAObject {
                doGet(data) {
                    const request = this.createRequest();
                    return request.doGet(data.get("url"), data.get("cb"));
                }
                post(data) {
                    const request = this.createRequest();
                    return request.post(data.get("url"), data.get("data"), data.get("cb"));
                }
                createRequest() {
                    const request = new HTTPRequest();
                    this.getRequests().push(request);
                    return request;
                }
                getRequests() {
                    return this.get("requests");
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("requests", []);
                }
            }
            Route.HARouter = HARouter;
            class HTTPRequest extends HA.HAObject {
                static createResponse(request) {
                    return new HTTPResponse(request);
                }
                doGet(url, cbFunction) {
                    return new Promise((resolve, reject) => {
                        const request = this.getRequest();
                        request.open("GET", url);
                        request.send();
                        const me = this;
                        request.onreadystatechange = () => {
                            if (request.readyState === 4) {
                                resolve(HTTPRequest.createResponse(me.getRequest()).toMap());
                            }
                        };
                    });
                }
                post(url, data, cbFunction) {
                    if (data instanceof Map) {
                        data.set("ts", Date.now());
                        data.set("_sh", screen.height);
                        data.set("_sw", screen.width);
                        data = HA.toObj(data);
                    }
                    else {
                        data.ts = Date.now();
                        data._sh = screen.height;
                        data._sw = screen.width;
                    }
                    return new Promise((resolve, reject) => {
                        const request = this.getRequest();
                        request.open("POST", url);
                        if (data instanceof FormData) {
                            request.send(data);
                        }
                        else {
                            request.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
                            const urlParameters = Object.keys(data).map((k) => {
                                return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
                            }).join("&");
                            request.send(urlParameters);
                        }
                        const me = this;
                        request.onreadystatechange = () => {
                            if (request.readyState === 4) {
                                resolve(HTTPRequest.createResponse(me.getRequest()).toMap());
                            }
                        };
                    });
                }
                ready() {
                    if (this.get("cbFunction")) {
                        return this.get("cbFunction")(HTTPRequest.createResponse(this.getRequest()));
                    }
                    return new Promise((resolve) => resolve(HTTPRequest.createResponse(this.getRequest())));
                }
                watch() {
                    const me = this;
                    this.getRequest().onreadystatechange = () => {
                        if (me.getRequest().readyState === 4) {
                            return me.ready();
                        }
                    };
                    return this.getRequest().onreadystatechange;
                }
                initialize(data) {
                    super.initialize(data);
                    const request = new XMLHttpRequest();
                    this.addToData("request", request);
                }
                getRequest() {
                    return this.get("request");
                }
            }
            Route.HTTPRequest = HTTPRequest;
            class HTTPResponse extends HA.HAObject {
                getJSON() {
                    return JSON.parse(this.getRequest().responseText);
                }
                toMap() {
                    return HA.toMap(this.getJSON());
                }
                initialize(request) {
                    const data = HA.toMap({ request });
                    super.initialize(data);
                }
                getRequest() {
                    return this.get("request");
                }
            }
            Route.HTTPResponse = HTTPResponse;
            Route.Router = new HARouter();
        })(Route = Core.Route || (Core.Route = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service) {
            var AppRepository = HA.Core.Repository.App;
            var FSApp = HA.Core.Entity.FSApp;
            var Tag = HA.Core.HTML.Tag;
            class App extends Service.Service {
                static createFSApp(data) {
                    return new FSApp(data);
                }
                getService(id) {
                    return this.get(id);
                }
                getWebPageService() {
                    return this.get("ha.service.webpage");
                }
                showExtPage(url) {
                    const app = HA.Core.Service.App.createFSApp(new HA.Core.HTML.ExtWindow(HA.toMap({ src: "/file/?redirect2=" + url })));
                    this.showFSApp(app);
                    return app.getId();
                }
                createAndShowFSApp(data) {
                    const app = HA.Core.Service.App.createFSApp(data);
                    this.showFSApp(app);
                    return app.getId();
                }
                showFSApp(app) {
                    this.getWebPageService().showFSApp(app);
                }
                closeFSApp(id) {
                    this.getWebPageService().removeApp(id);
                }
                findById(data, isNavigation) {
                    data.delete("cb");
                    const data2 = HA.toMap(data);
                    return this.getAppRepository().findById(data2, isNavigation);
                }
                createApp(data, elementData, isNavigation, nav) {
                    return this.getAppRepository().createApp(data, elementData, isNavigation);
                }
                processAction(data) {
                    var _a;
                    switch ((_a = data.get("t")) !== null && _a !== void 0 ? _a : data.get("todo")) {
                        case "toggleApp":
                            this.getWebPageService().toggleApp(data);
                            break;
                        case "showApp":
                            this.getWebPageService().showApp(data);
                            break;
                        case "app":
                        case "reloadApp":
                            this.getWebPageService().reloadApp(data);
                            break;
                        case "rc":
                        case "reloadCurrent":
                            this.getWebPageService().reloadApp(null);
                            break;
                        case "showAppMenu":
                            this.getWebPageService().showAppMenu(data);
                        case "showModal":
                        case "sm":
                            data.set("_m", "modal");
                            this.getWebPageService().showModal(data);
                            break;
                        case "rma":
                            this.getWebPageService().removeApp(data.get("id"));
                            break;
                        case "rmc":
                            this.getWebPageService().removeCurrentApp();
                            break;
                        case "rnav":
                            this.getWebPageService().reloadNav();
                        case "rp":
                            this.getWebPageService().reloadPreviousApp();
                            break;
                        case "service":
                            const service = HA.getService(data.get("id"));
                            service.process(data);
                            break;
                        case "msg":
                            HA.log(data);
                            break;
                        case "bulk":
                        case "steps":
                            this.processBulkAction(data.get("steps"));
                            break;
                        case "notw":
                            HA.NOTIFICATION.watch(data);
                            break;
                        case "idle":
                            HA.timeout(() => {
                                this.processAction(HA.toMap(data.get("data")));
                            }, data.get("d"));
                            break;
                        case "url":
                            HA.timeout(() => {
                                window.open(data.get("url"), data.get("target"));
                            }, 1000);
                            break;
                        case "dom":
                            this.updateDom(data);
                            break;
                        case "cc":
                            this.getAppRepository().clearCache();
                            break;
                        default:
                            break;
                    }
                }
                updateDom(data) {
                    const doma = "" + data.get("doma");
                    switch (doma) {
                        case "repl":
                            let t;
                            if (data.has("eid")) {
                                t = (new Tag()).findById(data.get("eid"), true);
                            }
                            else {
                                t = (new Tag()).findByQuery(data.get("eq"));
                            }
                            t.clear();
                            t.appendChild(new Tag(data.get("c")));
                            break;
                        default:
                    }
                }
                removeApp(id) {
                    this.getAppRepository().remove(id);
                }
                processBulkAction(data) {
                    for (const item of data) {
                        this.processAction(HA.toMap(item));
                    }
                }
                getAppRepository() {
                    if (!this.get("appRepository")) {
                        this.addToData("appRepository", new AppRepository(HA.toMap(this.getData())));
                    }
                    return this.get("appRepository");
                }
            }
            Service.App = App;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service) {
            class HorApp extends Service.Service {
                showApp(id) {
                    this.getPage().showApp(HA.toMap({ id: id }));
                }
                toggleApp(id) {
                    this.getPage().toggleApp(HA.toMap({ id: id }));
                }
                reloadApp(id) {
                    this.getPage().reloadApp(HA.toMap({ id: id }));
                }
                getPage() {
                    return this.get("pages");
                }
                initialize(data) {
                    this.addToData("pages", new Service.WebPage(data));
                }
            }
            Service.HorApp = HorApp;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class FacebookLoginBox extends HTML.Box {
                hasRedirection() {
                    return this.has("redirect");
                }
                getRedirectionData() {
                    return this.get("redirect");
                }
                initialize(data) {
                    super.initialize(data);
                    const element = this.get("element");
                    const redirect = {
                        r: element.getAttribute("r"),
                        id: element.getAttribute("rid"),
                        haid: element.getAttribute("haid"),
                    };
                    if (redirect) {
                        this.addToData("redirect", redirect);
                    }
                    this.addToData("button", new HTML.Form.Button({
                        element: element,
                        onClick: data.onClick,
                    }));
                }
                getVersion() {
                    return this.get("button").getAttribute("version");
                }
                getAppId() {
                    return this.get("button").getAttribute("appId");
                }
            }
            HTML.FacebookLoginBox = FacebookLoginBox;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service) {
            var FacebookLoginBox = HA.Core.HTML.FacebookLoginBox;
            var Tag = HA.Core.HTML.Tag;
            class LoginService extends Service.Service {
                initialize(data) {
                    super.initialize(data);
                    const me = this;
                    const t = new Tag(this.get("element"));
                    const e = t.findElementById("facebookLogin");
                    const fb = new FacebookLoginBox({
                        element: e,
                        onClick() {
                            me.login();
                        },
                    });
                    const hal = t.findById("haLogin");
                    hal.onClick(() => {
                        location.replace(hal.getAttribute("a"));
                    });
                    const har = t.findById("haRegistration");
                    har.onClick(() => {
                        location.replace(har.getAttribute("a"));
                    });
                    if (fb.hasRedirection()) {
                        this.addToData("redirect", fb.getRedirectionData());
                    }
                    this.addToData("loginBox", fb);
                }
                getLoginData() {
                    return this.get("userData");
                }
                getLoginBox() {
                    return this.get("loginBox");
                }
                getUserService() {
                    return this.getService("ha.service.user");
                }
                getPageService() {
                    return this.getService("ha.service.webpage");
                }
                getAppId() {
                    return this.get("id");
                }
                notifyError(data) {
                }
                login() {
                    const me = this;
                    const box = this.getLoginBox();
                    FB.init({
                        appId: box.getAppId(),
                        status: true,
                        xfbml: true,
                        version: box.getVersion(),
                    });
                    FB.login((response) => {
                        if (response.authResponse) {
                            me.submit(HA.toMap(response.authResponse));
                        }
                    }, {
                        scope: "public_profile,email",
                    });
                }
                hasRedirection() {
                    return this.has("redirect");
                }
                getRedirectionData() {
                    return HA.toMap(this.get("redirect"));
                }
                submit(data) {
                    const userService = this.getUserService(), me = this;
                    userService.loginFB(data).then((data) => {
                        if (me.hasRedirection()) {
                            const appData = me.getRedirectionData();
                            if (appData.get("r")) {
                                window.location.reload();
                                return;
                            }
                            if (appData.get("id")) {
                                me.getPageService().setMainApp(appData);
                                me.getPageService().showApp(appData);
                            }
                        }
                        me.getPageService().removeApp(me.getAppId());
                    }).catch((dataR) => {
                        me.notifyError(dataR);
                    });
                }
            }
            Service.LoginService = LoginService;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service) {
            var Body = HA.Core.Entity.PageBody;
            class PageBodyService extends Service.Service {
                reloadNav(nav) {
                    this.getBody().reloadNav(nav);
                }
                showAppMenu(menuData) {
                    this.getBody().showAppMenu(menuData);
                }
                getAppData() {
                    return this.getBody().getAttributes([
                        "id", "_id", "_1", "app", "nav", "q", "r", "navigationId", "controllerName",
                        "controllerNamespace", "d", "_e", "_s", "_m", "attribute", "mainid", "noReload"
                    ]);
                }
                getAppManager() {
                    return this.getBody().getAppManager();
                }
                showApp(app) {
                    const body = this.getBody();
                    if (body) {
                        return body.showApp(app);
                    }
                }
                getBody() {
                    return this.get("pageBody");
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("pageBody", new Body(data));
                }
            }
            Service.PageBodyService = PageBodyService;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service) {
            var Head = HA.Core.Entity.PageHead;
            class PageHead extends Service.Service {
                add2Head(data) {
                    this.getHead().add2Head(data);
                }
                getHead() {
                    return this.get("head");
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("head", new Head(data));
                }
            }
            Service.PageHead = PageHead;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service) {
            var UserEntity = HA.Core.Entity.User;
            var UserRepository = HA.Core.Repository.User;
            class User extends Service.Service {
                login(data) {
                    const me = this;
                    return this.getUserRepository().findByCredencial(data).then((response) => {
                        if (response.get("success")) {
                            const profile = HA.toMap(response.get("profile"));
                            me.updateUser(profile);
                            me.reloadNav();
                            return response.get("profile");
                        }
                        else {
                            return Promise.reject(HA.toMap(response));
                        }
                    });
                }
                loginFB(data) {
                    const me = this;
                    me.getPageService().removeApp("ha.user.menu");
                    return this.getUserRepository().findByCredencial(data).then((response) => {
                        if (response.get("success")) {
                            const profile = HA.toMap(response.get("profile"));
                            me.updateUser(profile);
                            if (profile.has("greet")) {
                                HA.notifyUser(HA.toMap(profile.get("greet")));
                            }
                            HA.timeout(() => {
                                me.reloadNav();
                                me.loadUserPreferedApp();
                            }, 100);
                            return response.get("profile");
                        }
                        else {
                            return Promise.reject(HA.toMap(response));
                        }
                    });
                }
                subscribe(func) {
                    const s = this.get("subscribers");
                    if (s) {
                        s.set(s.size, func);
                        func(this.getUser().getProfileData());
                    }
                }
                getUser() {
                    return this.get("user");
                }
                getUserRepository() {
                    return this.get("userRepository");
                }
                process(data) {
                    switch (data.get("a")) {
                        case "logout":
                            this.logout();
                            break;
                        case "refresh":
                            this.updateUserProfile();
                            break;
                    }
                }
                loadUserPreferedApp() {
                    this.getPageService().reloadApp(HA.toMap({ id: "main" }));
                }
                reloadNav() {
                    this.getPageService().reloadNav();
                }
                notifySubscribers() {
                    const s = this.get("subscribers");
                    const me = this;
                    if (s) {
                        s.forEach((func) => {
                            func(me.getUser().getProfileData());
                        });
                    }
                }
                updateUser(data) {
                    this.getUser().update(data);
                    this.notifySubscribers();
                }
                logout() {
                    const me = this;
                    return this.request(HA.toMap({ url: "/user/logout", data: {} })).then((response) => {
                        const cookies = document.cookie.split(";");
                        cookies.forEach((cookie) => {
                            const eqPos = cookie.indexOf("=");
                            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        });
                        me.getPageService().removeAll();
                        me.updateUserProfile();
                        HA.getAppService().processAction(response);
                    });
                }
                getPageService() {
                    return this.getService("ha.service.webpage");
                }
                request(data) {
                    return this.getRouter().post(data);
                }
                getRouter() {
                    return this.getService("router");
                }
                updateUserProfile() {
                    const me = this;
                    const data = new Map();
                    return this.getUserRepository().getUserProfile(data).then((response) => {
                        if (response.get("extra")) {
                            HA.getAppService().processAction(HA.toMap(response.get("extra")));
                        }
                        if (response.get("success")) {
                            const uData = HA.toMap(response.get("profile"));
                            me.updateUser(uData);
                        }
                        else {
                            return Promise.reject(response);
                        }
                    });
                }
                initialize(data) {
                    super.initialize(data);
                    this.addToData("userRepository", new UserRepository(data));
                    this.addToData("user", new UserEntity());
                    this.addToData("subscribers", new Map());
                    this.updateUserProfile();
                }
            }
            Service.User = User;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Service;
        (function (Service) {
            var AppService = HA.Core.Service.App;
            var UserService = HA.Core.Service.User;
            var HARouter = HA.Core.Route.HARouter;
            var HAApp = HA.Core.Entity.HAApp;
            var HANotification = HA.Core.Notification.HANotification;
            var Tag = HA.Core.HTML.Tag;
            var HANavigationApp = HA.Core.Entity.HANavigationApp;
            class WebPage extends Service.Service {
                showModal(data) {
                    data.set("_isModal", true);
                    this.reloadApp(data);
                }
                showApp2(app) {
                    this.addApp(app);
                    this.showApp(HA.toMap({ id: app.getId() }));
                }
                showAppMenu(data) {
                    this.getBody().showAppMenu(data);
                }
                reloadNav() {
                    const appData = this.getBody().getAppData();
                    appData.set("services", this.getServicesForApp());
                    if (appData.get("controllerName")) {
                        const me = this;
                        this.findApp(HA.toMap({
                            id: appData.get("navigationId"),
                        }), true).then((nav) => {
                            me.getBody().reloadNav(nav);
                        });
                    }
                }
                reloadApp(data) {
                    let id;
                    if (!data || !data.has("id")) {
                        data = this.getActiveAppData();
                        id = data.get("id") || data.get("_id");
                        const app = this.get("curApp");
                        if (app) {
                            app.savePosition();
                            data.set("position", app.getPosition());
                            data.delete("app");
                        }
                    }
                    id = id || data.get("id") || data.get("_id");
                    const me = this;
                    this.removeApp(id, false);
                    const history = this.getHistory();
                    const last = history.get(history.size - 1);
                    if (last && this.isSameApp(last, data)) {
                        history.delete(history.size - 1);
                    }
                    HA.timeout(() => { me.showApp(data); }, 5);
                }
                toggleApp(data) {
                    if (this.isActive(data.get("_id")) || this.isActive(data.get("id"))) {
                        this.showPrevious(false);
                    }
                    else {
                        this.showApp(data);
                    }
                }
                showPrevious(clean = true) {
                    if (!clean || this.clean()) {
                        const history = this.getHistory();
                        if (history.size <= 1) {
                            return;
                        }
                        history.delete(history.size - 1);
                        const data = history.get(history.size - 1);
                        history.delete(history.size - 1);
                        this.switchToApp(data);
                    }
                }
                toggleQMenu() {
                    if (this.get("qmenu")) {
                        this.get("qmenu")();
                    }
                }
                setQMenu(qmenu) {
                    this.addToData("qmenu", qmenu);
                }
                showApp(data) {
                    const history = this.getHistory();
                    const last = history.get(history.size - 1);
                    if (!last || !this.isSameApp(last, data)) {
                        if (data.get("id") === "main") {
                            data = this.get("mainApp");
                        }
                        this.switchToApp(data);
                    }
                }
                isSameApp(currentData, newData) {
                    if (currentData.get("id") === newData.get("id")) {
                        if (newData.has("_id") || currentData.has("_id")) {
                            return currentData.get("_id") === newData.get("_id");
                        }
                        else if (newData.has("fid") || currentData.has("fid")) {
                            return currentData.get("fid") === newData.get("fid");
                        }
                        return true;
                    }
                    return false;
                }
                getServicesForApp() {
                    return {
                        "ha.service.appManager": this.getBody().getAppManager(),
                        "ha.service.user": this.getUserService(),
                        "ha.service.webpage": this.getBaseApi(),
                        "router": new HARouter(),
                    };
                }
                getBaseApi() {
                    const me = this;
                    return {
                        isActive: (id) => {
                            return me.isActive(id);
                        },
                        notification: () => {
                            return me.getNotification();
                        },
                        reloadApp: (data) => {
                            me.reloadApp(data);
                        },
                        reloadNav: () => {
                            me.reloadNav();
                        },
                        reloadPreviousApp: () => {
                            return me.reloadPreviousApp();
                        },
                        removeAll: () => {
                            return me.removeAll();
                        },
                        removeApp: (id) => {
                            return me.removeApp(id);
                        },
                        removeCurrentApp: () => {
                            return me.removeCurrentApp();
                        },
                        replaceAppId: (id, newTd) => {
                            me.replaceAppId(id, newTd);
                        },
                        setMainApp: (d) => {
                            me.setMainApp(d);
                        },
                        showApp: (data) => {
                            me.showApp(data);
                        },
                        showAppMenu: (data) => {
                            me.showAppMenu(data);
                        },
                        showFSApp: (app) => {
                            me.showApp2(app);
                        },
                        showModal: (data) => {
                            me.showModal(data);
                        },
                        showPreviousApp: () => {
                            me.showPrevious();
                        },
                        toggleQMenu: () => {
                            me.toggleQMenu();
                        },
                        setQMenu: (qmenu) => {
                            me.setQMenu(qmenu);
                        },
                        subscribeToAppInfo: (func) => {
                            return me.subscribeToAppInfo(func);
                        },
                        unsubscribeToAppInfo: (subscriptionId) => {
                            return me.unsubscribeToAppInfo(subscriptionId);
                        },
                        toggleApp: (data) => {
                            me.toggleApp(data);
                        },
                    };
                }
                replaceAppId(id, newTd) {
                    let last = this.getActiveAppData();
                    if (!last) {
                        const history = this.getHistory();
                        for (let i = history.size; i >= 0; --i) {
                            const app = history.get(i);
                            if (app && app.get("id") === id) {
                                last = app;
                                break;
                            }
                        }
                    }
                    if (last) {
                        last.set("id", newTd);
                    }
                }
                subscribeToAppInfo(func) {
                    const appId = this.get("currAppId") || "main";
                    const subscriptionId = appId + '_' + (new Date().getTime());
                    this.getAppInfoWatchers().set(subscriptionId, func);
                    return [appId, subscriptionId];
                }
                unsubscribeToAppInfo(subscriptionId) {
                    this.getAppInfoWatchers().delete(subscriptionId);
                }
                getAppInfoWatchers() {
                    if (this.hasNot("appInfoWatchers")) {
                        this.addToData("appInfoWatchers", HA.toMap({}));
                    }
                    return this.get("appInfoWatchers");
                }
                notifyAppInfo(info) {
                    const appInfoWatchers = this.getAppInfoWatchers();
                    if (appInfoWatchers.size < 1) {
                        return;
                    }
                    appInfoWatchers.forEach((func) => {
                        func(info);
                    });
                }
                getServicesForBody() {
                    return {
                        "ha.service.webpage": this.getBaseApi(),
                        "router": new HARouter(),
                    };
                }
                getNotification() {
                    return this.get("ha.notification");
                }
                removeCurrentApp() {
                    let data = this.getActiveAppData();
                    if (!data) {
                        return;
                    }
                    if (this.getHistory().size === 1) {
                        this.reloadApp(HA.toMap({ id: "index" }));
                        return;
                    }
                    this.removeApp(data.get("_id") || data.get("id"));
                }
                reloadPreviousApp() {
                    this.removeCurrentApp();
                    HA.timeout(() => {
                        this.reloadApp();
                    }, 100);
                }
                removeApp(id, showPrevious = true) {
                    if (showPrevious && this.isActive(id)) {
                        this.showPrevious();
                    }
                    const app = this.getApps().get(id);
                    if (app) {
                        this.getApps().delete(id);
                        HA.getAppService().removeApp(id);
                        this.notifyAppInfo(HA.toMap({ id: app.getLocalId(), s: -1 }));
                    }
                }
                removeAll() {
                    this.getApps().clear();
                }
                isActive(id) {
                    if (!id) {
                        return false;
                    }
                    const last = this.getActiveAppData();
                    return (last && (last.get("_id") === id || last.get("id") === id));
                }
                getActiveAppData() {
                    const history = this.getHistory();
                    return history.get(history.size - 1);
                }
                addApp(app) {
                    this.getApps().set(app.getId(), app);
                }
                getApps() {
                    if (!this.get("apps")) {
                        this.addToData("apps", new Map());
                    }
                    return this.get("apps");
                }
                getUserService() {
                    if (!this.get("ha.service.user")) {
                        this.addToData("ha.service.user", new UserService({
                            services: {
                                "ha.service.webpage": this.getBaseApi(),
                                "router": new HARouter(),
                            },
                        }));
                    }
                    return this.get("ha.service.user");
                }
                findApp(data, isNavigation) {
                    const id = data.get("id") || data.get("_id");
                    const app = this.getApps().get(id);
                    if (app) {
                        data.set("ac", (data.get("ac") || 1) + 1);
                        return Promise.resolve(app);
                    }
                    const lid = HA.Core.Entity.Entity.genId();
                    data.set("ac", 1);
                    data.set("lid", lid);
                    if (!isNavigation) {
                        this.addToData("currAppId", lid);
                    }
                    return HA.getAppService().findById(data, isNavigation).then((app2) => {
                        if (data.has("position") && app2) {
                            app2.setPosition(data.get("position"));
                        }
                        app2.setLocalId(data.get("lid"));
                        return app2;
                    });
                }
                getHistory() {
                    return this.get("ha.history");
                }
                getHead() {
                    return this.get("ha.service.page.head");
                }
                getBody() {
                    return this.get("ha.service.page.body");
                }
                _showApp(app, data) {
                    this.addApp(app);
                    const history = this.getHistory();
                    if (app.isCachable()) {
                        history.set(history.size, data);
                    }
                    if (app.hasUrl()) {
                        if (data.get("ac") > 1) {
                            window.history.replaceState(data, app.getName(), app.getUrl());
                        }
                        else {
                            window.history.pushState(data, app.getName(), app.getUrl());
                        }
                    }
                    this.getHead().add2Head(app);
                    this.getBody().showApp(app);
                    this.addToData("curApp", app);
                    app.setViewed(true);
                    this.notifyAppInfo(HA.toMap({ id: app.getLocalId(), s: 1 }));
                }
                switchToApp(data) {
                    const me = this;
                    if (data.get("app")) {
                        this.addApp(data.get("app"));
                    }
                    this.findApp(data).then((app) => {
                        const id = app.getId();
                        if (id && (id !== data.get("_id") || id !== data.get("id"))) {
                            data.set("id", id);
                        }
                        me._showApp(app, data);
                    }).catch((e) => {
                        if ((e instanceof Map) && e.get("error")) {
                            HA.getAppService().processAction(HA.toMap(e.get("error")));
                        }
                        else {
                            HA.getAppService().processAction(HA.toMap(e));
                        }
                    });
                }
                initialize(data) {
                    const me = this;
                    super.initialize(data);
                    this.addToData("ha.history", new Map());
                    this.addToData("ha.notification", new HANotification({ debug: false }));
                    const pageBody = new Service.PageBodyService({ services: this.getServicesForBody() });
                    this.addToData("ha.service.page.body", pageBody);
                    this.addToData("ha.service.user", new UserService({
                        services: {
                            "ha.service.webpage": this.getBaseApi(),
                            "router": new HARouter(),
                        },
                    }));
                    HA.setAppService(new AppService(this.getServicesForApp()));
                    HA.setService4App(this.getServicesForApp());
                    this.addToData("ha.service.page.head", new Service.PageHead());
                    const appData = pageBody.getAppData();
                    if ("LoginService" !== appData.get("controllerName")) {
                        this.addToData("mainApp", appData);
                    }
                    if (appData.has("_m")) {
                        HA.log({ m: appData.get("_m"), d: 5000 });
                    }
                    HA.setAppId(appData.get("haId"));
                    if (appData.get("controllerName")) {
                        if (appData.get("_1")) {
                            this.getNotification().activateDebugMode();
                        }
                        else {
                            this.getNotification().deactivateDebugMode();
                        }
                        if (appData.get("noReload")) {
                            const element = document.querySelector("[apps]");
                            const navElement = document.querySelector("nav");
                            const appDataClone = HA.toMap(appData);
                            appDataClone.set("tag", new Tag({ element: navElement }));
                            appData.set("tag", new Tag({ element: element.firstChild }));
                            appData.set("navigation", new HANavigationApp(appDataClone));
                            const app = new HAApp(appData);
                            this.getHead().add2Head(app);
                            this.getBody().showApp(app);
                            this.addToData("curApp", app);
                            return;
                        }
                        if (appData.get("app")) {
                            if (appData.get("nav")) {
                                HA.getAppService().createApp(HA.toMap({ id: appData.get("navigationId") }), HA.toMap(JSON.parse(appData.get("nav"))), true);
                                appData.delete("nav");
                            }
                            HA.getAppService().createApp(appData, HA.toMap(JSON.parse(appData.get("app"))), false);
                            appData.delete("app");
                        }
                        if (appData.get("id")) {
                            this.reloadApp(appData);
                        }
                        else {
                            me._showApp(new HAApp(appData), appData);
                        }
                        this.reloadNav();
                    }
                    else {
                        this.showApp(appData);
                    }
                    window.onpopstate = (event) => {
                        this.showApp(event.state);
                    };
                    this.subscribeToAppInfo(this.get("jsNotification"));
                }
                clean() {
                    const me = this;
                    const apps = this.getApps();
                    apps.forEach((app) => {
                        if (!this.isActive(app.getId()) && app.isNotCachable() && app.isViewed()) {
                            me.removeApp(app.getId());
                        }
                    });
                    const histories = this.getHistory();
                    const newHistories = new Map();
                    histories.forEach((data, key) => {
                        const id = data.get("id");
                        const app = apps.get(id);
                        if (app && app.isNotNavigable() && app.isViewed()) {
                            histories.delete(key);
                        }
                        else {
                            newHistories.set(newHistories.size, data);
                        }
                    });
                    this.addToData("ha.history", HA.toMap(newHistories));
                    return true;
                }
                setMainApp(data) {
                    this.addToData("mainApp", data);
                }
            }
            Service.WebPage = WebPage;
        })(Service = Core.Service || (Core.Service = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var O1X;
(function (O1X) {
    function init(func) {
        new O1XWebPage({ jsNotification: func });
    }
    O1X.init = init;
    class O1XWebPage extends HA.HAObject {
        initialize(data) {
            super.initialize(data);
            this.addToData("horApp", new HA.Core.Service.HorApp(data));
        }
        preventUnload() {
            window.addEventListener("beforeunload", (event) => {
                event.preventDefault();
                event.returnValue = "";
            });
        }
    }
})(O1X || (O1X = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                var Tag = HA.Core.HTML.Tag;
                class FormItemController extends Controller.Controller {
                    static createController(data) {
                        const tag = new Tag(data);
                        const element = tag.findByAttribute("ft");
                        if (element) {
                            switch (element.getAttribute("ft")) {
                                case "mslct":
                                case "slct":
                                    return new Form.SelectController(data);
                                case "txt":
                                    data.set("textarea", 1);
                                case "txtl":
                                    return new Form.TextController(data);
                                case "mtxt":
                                    return new Form.MultiTextController(data);
                                case "fs":
                                    return new Form.FileController(data);
                                case "mm":
                                    return new Form.MultiMediaController(data);
                                case "checkbox":
                                    return new Form.CheckboxController(data);
                                default:
                                    break;
                            }
                            return new FormItemController(data);
                        }
                    }
                    reset() {
                        this.getTag().reset();
                    }
                    getValue() {
                        return this.getTag().getValue();
                    }
                    isInputItem() {
                        return false;
                    }
                    getItemType() {
                        return this.getTag().getType();
                    }
                    getName() {
                        return this.getTag().getName();
                    }
                    getTag() {
                        return super.getTag();
                    }
                    getTitle() {
                        return this.getTag().getTitle();
                    }
                    getAttr(name) {
                        return this.getTag().getAttr(name);
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.initItem();
                    }
                    initItem() {
                        this.setTag(this.createItem());
                    }
                    createItem() {
                        const element = this.getTag().findByAttribute("ft");
                        const data = HA.toMap({ tag: this.getTag() });
                        const me = this;
                        let t = "FormItem";
                        if (element) {
                            switch (element.getAttribute("ft")) {
                                case "btn":
                                    t = FormItemController.TYPE_BTN_ITEM;
                                    data.set("click", () => {
                                        me.getFormController().processBtnClick(me.getTag());
                                    });
                                    break;
                                default:
                                    break;
                            }
                        }
                        this.addToData("itemType", t);
                        return HA.createService(HA.Core.HTML.Form, t, data);
                    }
                    replaceItems(items) {
                        this.getTag().replaceItems(items);
                    }
                    getChoices() {
                        return this.getTag().getChoices();
                    }
                    getFormController() {
                        return this.get("formController");
                    }
                    setAppId(id) {
                        return this.addToData("_appId", id);
                    }
                    getAppId() {
                        return this.get("_appId");
                    }
                }
                FormItemController.TYPE_BTN_ITEM = "Button";
                Form.FormItemController = FormItemController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class FormItem extends HTML.Div {
                    getName() {
                        return this.getAttribute("id");
                    }
                    reset() {
                        return this.getITag().clear();
                    }
                    getValue() {
                        return this.getITag().getText();
                    }
                    getType() {
                        return "FormType";
                    }
                    getTitle() {
                        return this.getAttr("t");
                    }
                    getAttr(name) {
                        const tag = this.findByAttribute("info");
                        return tag ? tag.getAttribute(name) : null;
                    }
                    getITag() {
                        return this.get("itag");
                    }
                    createItemTag(formItem) {
                        const label = this.trans("label");
                        const formElementTitle = label ? {
                            c: [
                                {
                                    class: "formititle",
                                    t: "div",
                                    txt: label,
                                },
                                {
                                    attributes: [
                                        { n: "counter", v: 1 },
                                    ],
                                    class: "counter",
                                    t: "div",
                                },
                            ],
                            class: "formihead",
                            t: "fc",
                        } : null;
                        return new HTML.Tag({
                            attributes: [
                                { n: "formi", v: 1 },
                                { n: "id", v: this.getId() || "fi" + this.get("name") },
                            ],
                            c: [
                                { t: "div", class: "state" },
                                {
                                    c: [
                                        {
                                            attributes: [
                                                { n: "name", v: this.get("name") },
                                                { n: "n", v: this.get("name") },
                                                { n: "max", v: this.get("max") },
                                                { n: "t", v: this.trans("label") },
                                                { n: "info", v: 1 },
                                                { n: "choices", v: this.translate(this.get("choices")) },
                                            ],
                                            c: [
                                                {
                                                    c: [
                                                        formElementTitle,
                                                        {
                                                            c: [formItem],
                                                            class: "tbxc",
                                                            t: "div",
                                                        }
                                                    ],
                                                    t: "cfc",
                                                }
                                            ],
                                            class: "textline",
                                            t: "div",
                                        }
                                    ],
                                    class: "ibox",
                                    t: "div",
                                },
                            ],
                            class: "formi",
                            t: "div",
                        });
                    }
                }
                Form.FormItem = FormItem;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Select extends Form.FormItem {
                    reset() {
                        this.replaceItems([]);
                        return this;
                    }
                    replaceItems(items) {
                        this.getEntries().replaceItems(items);
                        const t = this.findByAttribute("counter");
                        t.setText(items.length + "/" + this.getChoicesLength());
                    }
                    getSelected() {
                        return this.getEntries().getValues();
                    }
                    getType() {
                        return "Select";
                    }
                    getChoices() {
                        const r = new Map();
                        const tag = this.findByAttribute("info");
                        let choices = tag.getAttribute("choices");
                        if (choices) {
                            choices = JSON.parse(choices);
                            const me = this;
                            choices.forEach((c) => {
                                r.set(c, HA.toMap({ v: c, s: me.isSelected(c) }));
                            });
                        }
                        return r;
                    }
                    getChoicesLength() {
                        const tag = this.findByAttribute("info");
                        const max = tag.getAttribute("max");
                        if (max && max !== "undefined") {
                            return max;
                        }
                        const choices = tag.getAttribute("choices");
                        if (choices) {
                            return JSON.parse(choices).length;
                        }
                        return 0;
                    }
                    isSelected(value) {
                        let r = false;
                        this.getEntries().getItems().forEach((e) => {
                            if (e.equals(value)) {
                                r = true;
                                return;
                            }
                        });
                        return r;
                    }
                    getEntries() {
                        return this.get("entries");
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.addToData("entries", new HTML.List({
                            entryClass: HTML.SelectEntry,
                            itemTagClass: this.getItemTagClass(),
                            tag: this.findByAttribute("ic"),
                        }));
                        const me = this;
                        if (this.has("trans")) {
                            const selected = this.translate("#" + this.get("name"));
                            if (selected && selected.length > 0) {
                                selected.forEach((i) => {
                                    if (!i || i === "") {
                                        return;
                                    }
                                    me.add(i);
                                });
                            }
                        }
                    }
                    add(item) {
                        this.getEntries().addItem(item);
                    }
                    getItemTagClass() {
                        return HTML.TextItemEntry;
                    }
                    getMax() {
                        return parseInt(this.getAttr("max"));
                    }
                    createSelf() {
                        const c = this.createItemTag({
                            attributes: [
                                { n: "ft", v: this.get("ft") },
                            ],
                            c: [
                                {
                                    attributes: [
                                        { n: "ic", v: 1 },
                                    ],
                                    class: "fwrap",
                                    t: "fc",
                                }
                            ],
                            class: "itemsbox",
                            t: "div",
                        });
                        this.setElement(c.getElement());
                    }
                }
                Form.Select = Select;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Window extends HTML.CFlexContainer {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("w");
                    this.initController();
                }
                initController() {
                    const wca = this.translate("#wca");
                    if (wca) {
                        this.addToData("wcancel", () => {
                            HA.getAppService().processAction(HA.toMap(wca));
                        });
                    }
                    const waa = this.translate("#waa");
                    if (waa) {
                        this.addToData("waccept", () => {
                            HA.getAppService().processAction(HA.toMap(waa));
                        });
                    }
                    if (!this.get("wcancel") || !(this.get("wcancel") instanceof Function)) {
                        this.addToData("wcancel", () => {
                            HA.getWebPageService().removeCurrentApp();
                        });
                    }
                    this.createControlPanel();
                }
                createControlPanel() {
                    let t = this.get("title");
                    if (!t && this.hasTrans("#wt")) {
                        t = this.translate("#wt");
                    }
                    const cp = new HTML.WindowHead(HA.toMap({
                        accept: this.get("waccept"),
                        cancel: this.get("wcancel"),
                        title: t,
                    }));
                    this.addToData("controlPanel", cp);
                    this.insertOnTop(cp);
                }
                createByType(data, main) {
                    HTML.Page.createNewByType(data, main);
                }
            }
            HTML.Window = Window;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class Selector extends HTML.Window {
                    select(item) {
                        this.getItems().forEach((s) => {
                            if (s && s.equals(item)) {
                                s.checked();
                            }
                        });
                    }
                    deselectAll() {
                        this.getItems().forEach((s) => {
                            s.unchecked();
                        });
                    }
                    getSelections() {
                        const data = [];
                        this.getItems().forEach((s) => {
                            if (s && s.isChecked()) {
                                data.push(s.getValue());
                            }
                        });
                        return data;
                    }
                    getItems() {
                        return this.getList().getItems();
                    }
                    getList() {
                        return this.get("list");
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.appendChild(this.createHead());
                        this.addClass("ds");
                        this.initList();
                    }
                    initList() {
                        const me = this;
                        const list = new HTML.List(new HTML.CFlexContainer());
                        list.addClass("dl");
                        const dataList = this.get("dlist");
                        if (dataList) {
                            dataList.forEach((data) => {
                                list.addItem(me.createItem(data));
                            });
                        }
                        this.addToData("list", list);
                        this.appendChild(list);
                    }
                    createHead(data) {
                        return new HTML.SelectorHead(data);
                    }
                    createItem(data) {
                        if (this.has("pfunc")) {
                            data.set("pfunc", this.get("pfunc").itemClick);
                        }
                        return new Editor.SelectorItem(data);
                    }
                }
                Editor.Selector = Selector;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                var Selector = HA.Core.HTML.Editor.Selector;
                var Select = HA.Core.HTML.Form.Select;
                class CheckboxController extends Form.FormItemController {
                    getValue() {
                        return this.getTag().getSelected();
                    }
                    isInputItem() {
                        return true;
                    }
                    createItem() {
                        const data = HA.toMap({ tag: this.getTag() });
                        const me = this;
                        data.set("click", () => {
                            const tag = new Selector(HA.toMap({
                                dlist: me.getChoices(),
                                pfunc: {
                                    itemClick: (d) => {
                                        me.itemClicked(d, tag);
                                    },
                                },
                                title: me.getTitle(),
                                waccept: () => {
                                    me.wAccept(tag.getSelections());
                                },
                                wcancel: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                },
                            }));
                            const app2 = HA.Core.Service.App.createFSApp(tag);
                            me.setAppId(app2.getId());
                            me.getFormController().showSelection(app2);
                        });
                        return new Select(data);
                    }
                    replaceItems(items) {
                        this.getTag().replaceItems(items);
                    }
                    getChoices() {
                        return this.getTag().getChoices();
                    }
                    initItem() {
                        super.initItem();
                        this.addToData("max", this.getTag().getMax());
                    }
                    itemClicked(data, tag) {
                        const max = this.get("max");
                        if (!max || max > tag.getSelections().length) {
                            return;
                        }
                        if (max === 1) {
                            tag.deselectAll();
                            tag.select(data);
                        }
                        this.wAccept(tag.getSelections());
                    }
                    wAccept(selections) {
                        this.getFormController().closeSelection(this.getAppId());
                        this.replaceItems(selections);
                        const me = this;
                        HA.timeout(() => { me.getTag().scrollIntoView(); }, 200);
                    }
                }
                Form.CheckboxController = CheckboxController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class HAFile extends Form.Select {
                    getType() {
                        return "MultiText";
                    }
                    getChoices() {
                        const r = new Map();
                        const choices = this.getSelected();
                        if (choices) {
                            const me = this;
                            choices.forEach((c) => {
                                if (c instanceof HTML.Tag) {
                                    r.set(r.size, HA.toMap({ item: c, s: me.isSelected(c) }));
                                    return;
                                }
                                r.set(c, HA.toMap({ v: c, s: me.isSelected(c) }));
                            });
                        }
                        return r;
                    }
                    getChoicesLength() {
                        return 0;
                    }
                    isSelected(value) {
                        return true;
                    }
                }
                Form.HAFile = HAFile;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class MultiText extends Editor.Selector {
                    addText(txt) {
                        if (!this.getList().hasValue(txt) && txt.toString().trim().length > 0) {
                            this.getList().addItem(new Editor.TextItem(HA.toMap({ v: txt, s: true })));
                        }
                    }
                    createItem(data) {
                        return new Editor.TextItem(data);
                    }
                    createHead(data) {
                        const me = this;
                        return new HTML.MultiTextHead(HA.toMap({
                            ed: {
                                addText(txt) {
                                    me.addText(txt);
                                },
                            },
                            max: this.get("max"),
                        }));
                    }
                }
                Editor.MultiText = MultiText;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class File extends Editor.MultiText {
                    getSelections() {
                        const data = [];
                        this.getItems().forEach((s) => {
                            if (s.isChecked()) {
                                data.push(s.getValue());
                            }
                        });
                        return data;
                    }
                    getItems() {
                        return this.getList().getItems();
                    }
                    getList() {
                        return this.get("list");
                    }
                    addFiles(files) {
                        for (let i = 0; i < files.length; i++) {
                            this.addFile(files[i]);
                        }
                    }
                    addFile(file) {
                        if (file && !this.getList().hasValue(file.name)) {
                            const imgContainer = new Editor.FileContainer(HA.toMap({ f: file }));
                            const div = new HTML.Div({ className: "thumb" });
                            div.appendChild(new HTML.Img(HA.toMap({ src: this.getFileIcon(file) })));
                            imgContainer.appendChild(div);
                            this.getList().addItem(new Editor.ImageItem(HA.toMap({ item: imgContainer, s: true })));
                        }
                    }
                    getFileIcon(file) {
                        switch (file.type) {
                            case "application/pdf":
                                return "/file/ha/svg/file_pdf";
                            case "application/json":
                                return "/file/ha/svg/file_json";
                            default:
                                return "/file/ha/svg/file_pdf";
                        }
                    }
                    createItem(data) {
                        return new Editor.TextItem(data);
                    }
                    createHead(data) {
                        const me = this;
                        return new HTML.MultiTextHead(HA.toMap({
                            accept: ".json,application/json,.pdf,application/pdf",
                            ed: {
                                addFiles: (files) => {
                                    if (files) {
                                        me.addFiles(files);
                                    }
                                },
                            },
                            t: "json",
                        }));
                    }
                }
                Editor.File = File;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class SelectorItem extends HTML.FlexContainer {
                    getValue() {
                        return this.get("v") || this.get("item");
                    }
                    equals(val) {
                        return this.getValue() === val;
                    }
                    isChecked() {
                        return !!this.get("s");
                    }
                    toggleSelection() {
                        if (this.has("pfunc")) {
                            this.get("pfunc")(this.getValue());
                        }
                        if (this.isChecked()) {
                            this.unchecked();
                        }
                        else {
                            this.checked();
                        }
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.addClass("si");
                        this.addToData("id", this.getValue());
                        const me = this;
                        let div = null;
                        if (this.has("v")) {
                            div = new HTML.Div(this.get("v"));
                        }
                        else if (this.has("item")) {
                            div = this.get("item");
                        }
                        this.onClick(() => {
                            me.toggleSelection();
                        });
                        this.addToData("icon", new HTML.Div());
                        this.addToData("txt", div);
                        if (this.isChecked()) {
                            this.checked();
                        }
                        this.appendChildRight(this.getIcon());
                        this.appendChild(div);
                    }
                    getIcon() {
                        return this.get("icon");
                    }
                    getTextTag() {
                        return this.get("txt");
                    }
                    checked() {
                        this.getIcon().addClass("checked");
                        this.addClass("_checked");
                        this.addToData("s", true);
                    }
                    unchecked() {
                        this.getIcon().removeClass("checked");
                        this.removeClass("_checked");
                        this.addToData("s", false);
                    }
                }
                Editor.SelectorItem = SelectorItem;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class FileContainer extends HTML.FlexContainer {
                    getFileData() {
                        return this.get("fdata");
                    }
                    getFile() {
                        return this.get("f");
                    }
                    initialize(data) {
                        super.initialize(data);
                        const file = this.getFile();
                        const reader = new FileReader();
                        const me = this;
                        reader.onload = (event) => {
                            me.addToData("fdata", {
                                date: file.lastModified,
                                fileData: event.target.result,
                                name: file.name,
                                size: file.size,
                                type: file.type,
                            });
                        };
                        reader.readAsDataURL(file);
                    }
                }
                Editor.FileContainer = FileContainer;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                var HAFile = HA.Core.HTML.Form.HAFile;
                var FileEditor = HA.Core.HTML.Editor.File;
                var FileContainer = HA.Core.HTML.Editor.FileContainer;
                class FileController extends Form.FormItemController {
                    getValue() {
                        const list = this.getTag().getSelected(), res = [];
                        list.forEach((item) => {
                            if (item instanceof FileContainer) {
                                res.push(item.getFile());
                            }
                            else {
                                res.push(item);
                            }
                        });
                        return res;
                    }
                    isInputItem() {
                        return true;
                    }
                    createItem() {
                        const data = HA.toMap({ tag: this.getTag() });
                        const me = this;
                        data.set("click", () => {
                            const tag = new FileEditor(HA.toMap({
                                dlist: me.getChoices(),
                                title: me.getTitle(),
                                waccept: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                    me.replaceItems(tag.getSelections());
                                },
                                wcancel: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                },
                            }));
                            const app2 = HA.Core.Service.App.createFSApp(tag);
                            me.setAppId(app2.getId());
                            me.getFormController().showSelection(app2);
                        });
                        return new HAFile(data);
                    }
                    replaceItems(items) {
                        this.getTag().replaceItems(items);
                    }
                    getChoices() {
                        return this.getTag().getChoices();
                    }
                }
                Form.FileController = FileController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                class FormController extends Controller.Controller {
                    closeSelection(id) {
                        HA.getAppService().closeFSApp(id);
                    }
                    showSelection(app) {
                        HA.getAppService().showFSApp(app);
                    }
                    processBtnClick(tag) {
                        const data = new Map();
                        const form = new FormData();
                        const me = this;
                        const btn = tag.findElementByAttribute("formid");
                        if (btn) {
                            data.set("formId", btn.getAttribute("formid"));
                            form.append("formId", btn.getAttribute("formid"));
                        }
                        this.getItemControllers().forEach((ic) => {
                            if (ic.isInputItem()) {
                                if (ic instanceof Form.MultiMediaController) {
                                    const files = ic.getValue();
                                    let i = 1;
                                    const medias = [];
                                    files.forEach((file) => {
                                        if (file instanceof File) {
                                            form.append("media_" + i, file);
                                            ++i;
                                        }
                                        else {
                                            medias.push(file);
                                        }
                                    });
                                    if (medias.length > 0) {
                                        form.append("medias", JSON.stringify(medias));
                                    }
                                }
                                else if (ic instanceof Form.FileController) {
                                    const files = ic.getValue();
                                    let i = 1;
                                    const medias = [];
                                    files.forEach((file) => {
                                        if (file instanceof File) {
                                            form.append("file_" + i, file);
                                            ++i;
                                        }
                                        else {
                                            medias.push(file);
                                        }
                                    });
                                    if (medias.length > 0) {
                                        form.append("files", JSON.stringify(medias));
                                    }
                                }
                                else {
                                    data.set(ic.getAttr("n"), ic.getValue());
                                    form.append(ic.getAttr("n"), ic.getValue());
                                }
                            }
                        });
                        HA.getDataRepository().saveForm(form).then((response) => {
                            const todo = response.get("todo");
                            if (todo) {
                                switch (todo) {
                                    case "success":
                                        me.reset();
                                        if (response.get("msg")) {
                                            HA.log(response.get("msg"));
                                        }
                                        if (response.get("id")) {
                                            HA.getWebPageService().reloadApp(response);
                                        }
                                        break;
                                    case "app":
                                        HA.getWebPageService().reloadApp(response);
                                        break;
                                    case "error":
                                        if (response.get("msg")) {
                                            HA.log(response.get("msg"));
                                        }
                                        break;
                                    default:
                                        HA.getAppService().processAction(response);
                                        break;
                                }
                            }
                            else if (response.has("app")) {
                                HA.getWebPageService().showApp(response);
                            }
                            else {
                                HA.getAppService().processAction(response);
                            }
                        }).catch((reason) => {
                            HA.log(["eRRRR", reason]);
                        });
                    }
                    reset() {
                        this.getItemControllers().forEach((ic) => {
                            if (ic.isInputItem()) {
                                ic.reset();
                            }
                        });
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.initItems();
                    }
                    initItems() {
                        const me = this;
                        const formi = this.getTag().fetchByAttribute("formi");
                        formi.forEach((item) => {
                            me.addItemController(Form.FormItemController.createController(HA.toMap({ tag: item, formController: me })));
                        });
                    }
                    addItemController(itemController) {
                        this.getItemControllers().set(itemController.getName(), itemController);
                    }
                    getItemControllers() {
                        if (this.hasNot("itemControllers")) {
                            this.addToData("itemControllers", new Map());
                        }
                        return this.get("itemControllers");
                    }
                }
                Form.FormController = FormController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class MultiMedia extends Form.HAFile {
                    getType() {
                        return "MultiText";
                    }
                    getChoices() {
                        const r = new Map();
                        const choices = this.getSelected();
                        if (choices) {
                            const me = this;
                            choices.forEach((c) => {
                                if (c instanceof HTML.Tag) {
                                    r.set(r.size, HA.toMap({ item: c, s: me.isSelected(c) }));
                                    return;
                                }
                                r.set(c, HA.toMap({ v: c, s: me.isSelected(c) }));
                            });
                        }
                        return r;
                    }
                    getChoicesLength() {
                        return 0;
                    }
                    isSelected(value) {
                        return true;
                    }
                    add(item) {
                        if (typeof item === "string") {
                            item = new HTML.Div(new HTML.Img(HA.toMap({ class: "thumb", src: item })));
                        }
                        super.add(item);
                    }
                }
                Form.MultiMedia = MultiMedia;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class MultiMedia extends Editor.MultiText {
                    getSelections() {
                        const data = [];
                        this.getItems().forEach((s) => {
                            if (s.isChecked()) {
                                data.push(s.getValue());
                            }
                        });
                        return data;
                    }
                    getItems() {
                        return this.getList().getItems();
                    }
                    getList() {
                        return this.get("list");
                    }
                    addImageFiles(files) {
                        for (const file of files) {
                            this.addImageFile(file);
                        }
                        if (this.has("pfunc") && this.has("max") && files.length >= this.get("max")) {
                            this.get("pfunc").itemClick(this.getSelections());
                        }
                    }
                    addImageFile(file) {
                        if (file && !this.getList().hasValue(file.name)) {
                            const imgContainer = new Editor.MediaContainer(HA.toMap({ f: file }));
                            const div = new HTML.Div({ className: "thumb" });
                            div.appendChild(new HTML.Img(HA.toMap({ f: file })));
                            imgContainer.appendChild(div);
                            this.getList().addItem(new Editor.ImageItem(HA.toMap({ item: imgContainer, s: true })));
                        }
                    }
                    createItem(data) {
                        return new Editor.TextItem(data);
                    }
                    createHead(data) {
                        const me = this;
                        return new HTML.MultiTextHead(HA.toMap({
                            accept: me.get("encodings") || "image/x-png,image/gif,image/jpeg,image/svg+xml",
                            ed: {
                                addImageFile: (file) => {
                                    if (file) {
                                        me.addImageFile(file);
                                    }
                                },
                                addImageFiles: (files) => {
                                    if (files) {
                                        me.addImageFiles(files);
                                    }
                                },
                            },
                            max: me.get("max"),
                            t: me.get("t") || "img/url",
                            tc: me.get("tc"),
                        }));
                    }
                }
                Editor.MultiMedia = MultiMedia;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class MediaContainer extends Editor.FileContainer {
                }
                Editor.MediaContainer = MediaContainer;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                var MultiMedia = HA.Core.HTML.Form.MultiMedia;
                var MultiMediaEditor = HA.Core.HTML.Editor.MultiMedia;
                var MediaContainer = HA.Core.HTML.Editor.MediaContainer;
                class MultiMediaController extends Form.FormItemController {
                    getValue() {
                        const list = this.getTag().getSelected(), res = [];
                        list.forEach(function (item) {
                            if (item instanceof MediaContainer) {
                                res.push(item.getFile());
                            }
                            else {
                                res.push(item);
                            }
                        });
                        return res;
                    }
                    isInputItem() {
                        return true;
                    }
                    createItem() {
                        const data = HA.toMap({ tag: this.getTag() });
                        const me = this;
                        data.set("click", () => {
                            const tag = new MultiMediaEditor(HA.toMap({
                                dlist: me.getChoices(),
                                title: me.getTitle(),
                                waccept: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                    me.replaceItems(tag.getSelections());
                                },
                                wcancel: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                },
                            }));
                            const app2 = HA.Core.Service.App.createFSApp(tag);
                            me.setAppId(app2.getId());
                            me.getFormController().showSelection(app2);
                        });
                        return new MultiMedia(data);
                    }
                    replaceItems(items) {
                        this.getTag().replaceItems(items);
                    }
                    getChoices() {
                        return this.getTag().getChoices();
                    }
                }
                Form.MultiMediaController = MultiMediaController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class MultiText extends Form.Select {
                    replaceItems(items) {
                        this.getEntries().replaceItems(items);
                        const t = this.findByAttribute("counter");
                        t.setText(items.length);
                    }
                    getType() {
                        return "MultiText";
                    }
                    getChoices() {
                        const r = new Map();
                        const choices = this.getSelected();
                        if (choices) {
                            const me = this;
                            choices.forEach((c) => {
                                r.set(c, HA.toMap({ v: c, s: me.isSelected(c) }));
                            });
                        }
                        return r;
                    }
                    getChoicesLength() {
                        return 0;
                    }
                    isSelected(value) {
                        return true;
                    }
                }
                Form.MultiText = MultiText;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                var MultiText = HA.Core.HTML.Form.MultiText;
                var MultiTextEditor = HA.Core.HTML.Editor.MultiText;
                class MultiTextController extends Form.FormItemController {
                    getValue() {
                        return this.getTag().getSelected();
                    }
                    isInputItem() {
                        return true;
                    }
                    createItem() {
                        const data = HA.toMap({ tag: this.getTag() });
                        const me = this;
                        data.set("click", () => {
                            const tag = new MultiTextEditor(HA.toMap({
                                dlist: me.getChoices(),
                                title: me.getTitle(),
                                waccept: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                    me.replaceItems(tag.getSelections());
                                },
                                wcancel: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                },
                            }));
                            const app2 = HA.Core.Service.App.createFSApp(tag);
                            me.setAppId(app2.getId());
                            me.getFormController().showSelection(app2);
                        });
                        return new MultiText(data);
                    }
                    replaceItems(items) {
                        this.getTag().replaceItems(items);
                    }
                    getChoices() {
                        return this.getTag().getChoices();
                    }
                }
                Form.MultiTextController = MultiTextController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                var Selector = HA.Core.HTML.Editor.Selector;
                var Select = HA.Core.HTML.Form.Select;
                class SelectController extends Form.FormItemController {
                    getValue() {
                        return this.getTag().getSelected();
                    }
                    isInputItem() {
                        return true;
                    }
                    createItem() {
                        const data = HA.toMap({ tag: this.getTag() });
                        const me = this;
                        data.set("click", () => {
                            const tag = new Selector(HA.toMap({
                                dlist: me.getChoices(),
                                pfunc: {
                                    itemClick: (d) => {
                                        me.itemClicked(d, tag);
                                    },
                                },
                                title: me.getTitle(),
                                waccept: () => {
                                    me.wAccept(tag.getSelections());
                                },
                                wcancel: () => {
                                    me.getFormController().closeSelection(me.getAppId());
                                },
                            }));
                            const app2 = HA.Core.Service.App.createFSApp(tag);
                            me.setAppId(app2.getId());
                            me.getFormController().showSelection(app2);
                        });
                        return new Select(data);
                    }
                    replaceItems(items) {
                        this.getTag().replaceItems(items);
                    }
                    getChoices() {
                        return this.getTag().getChoices();
                    }
                    initItem() {
                        super.initItem();
                        this.addToData("max", this.getTag().getMax());
                    }
                    itemClicked(data, tag) {
                        const max = this.get("max");
                        if (!max || max > tag.getSelections().length) {
                            return;
                        }
                        if (max === 1) {
                            tag.deselectAll();
                            tag.select(data);
                        }
                        this.wAccept(tag.getSelections());
                    }
                    wAccept(selections) {
                        this.getFormController().closeSelection(this.getAppId());
                        this.replaceItems(selections);
                        const me = this;
                        HA.timeout(() => { me.getTag().scrollIntoView(); }, 200);
                    }
                }
                Form.SelectController = SelectController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Text extends Form.FormItem {
                    getType() {
                        return "Text";
                    }
                    getValue() {
                        const tag = this.getITag();
                        return tag.getStripText();
                    }
                    initialize(data) {
                        super.initialize(data);
                        let t = null;
                        if (this.getTag()) {
                            t = this.getTag().findByTag("input") || this.getTag().findByTag("textarea");
                        }
                        else {
                            t = this.findByTag("input") || this.findByTag("textarea");
                        }
                        this.addToData("itag", this.get("textarea") ? new Form.Textarea(t) : new Form.Input(t));
                        const me = this;
                        if (this.get("textarea")) {
                            const t = me.getITag();
                            const listenerF = () => {
                                if (me.has("remL")) {
                                    return;
                                }
                                t.fixHeight();
                                t.focus();
                                me.addToData("remL", true);
                            };
                            this.addListener("input", listenerF);
                            t.fixHeight();
                            t.focus();
                        }
                    }
                    createSelf() {
                        let input = null, val = this.trans("value");
                        const attrs = [
                            { n: "ft", v: "txtl" },
                            { n: "type", v: this.get("it") || "text" },
                            { n: "contenteditable", v: true },
                        ];
                        if (this.get("it") !== "date" && this.get("it") !== "datetime-local") {
                            attrs.push({ n: "placeholder", v: this.get("ph") || this.trans("label") });
                        }
                        else if (this.get("it") !== "datetime-local") {
                            if (val) {
                                const date = new Date(val);
                                val = date.toJSON().slice(0, 10);
                            }
                        }
                        else {
                            attrs.push({ n: "min", v: this.trans("dtmin") });
                        }
                        attrs.push({ n: "value", v: val });
                        if (this.get("ft") === "txtl") {
                            input = {
                                attributes: attrs,
                                class: "textlinebox",
                                t: "input",
                                it: this.get("it"),
                            };
                        }
                        else {
                            input = {
                                attributes: [
                                    { n: "ft", v: "txt" },
                                    { n: "contenteditable", v: true },
                                    { n: "placeholder", v: this.get("ph") || this.trans("label") },
                                    { n: "value", v: this.trans("value") },
                                ],
                                class: "textbox",
                                t: "textarea",
                                v: this.trans("value"),
                            };
                        }
                        const c = this.createItemTag(input);
                        this.setElement(c.getElement());
                    }
                }
                Form.Text = Text;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Form;
            (function (Form) {
                var Text = HA.Core.HTML.Form.Text;
                class TextController extends Form.FormItemController {
                    isInputItem() {
                        return true;
                    }
                    createItem() {
                        return new Text(HA.toMap({ tag: this.getTag(), textarea: this.get("textarea") }));
                    }
                }
                Form.TextController = TextController;
            })(Form = Controller.Form || (Controller.Form = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Menu;
            (function (Menu_1) {
                var MenuGridTag = HA.Core.HTML.Container;
                class Menu extends Controller.Controller {
                    initialize(data) {
                        super.initialize(data);
                        this.addToData("tag", new MenuGridTag(HA.toMap(data)));
                        this.initializeItems();
                    }
                    initializeItems() {
                        this.addToData("itemControllers", new Map());
                        const items = this.getItems();
                        if (items) {
                            const me = this;
                            items.forEach((item) => {
                                me.addItem(HA.toMap(item));
                            });
                        }
                    }
                    addItem(data) {
                        const config = HA.toMap(data);
                        config.set("services", this.getItemService());
                        config.set("pelement", this.get("tag"));
                        this.getItemControllers().set(data.get("id"), this.createItemController(config));
                    }
                    createItemController(data) {
                        if (data.has("controllerName")) {
                            return HA.createService(HA.Core.Controller.Menu, data.get("controllerName"), data);
                        }
                        return new Menu_1.MenuItem(data);
                    }
                    getItemService() {
                        return this.get("services");
                    }
                    getItemControllers() {
                        return this.get("itemControllers");
                    }
                    getItems() {
                        return this.get("items");
                    }
                }
                Menu_1.Menu = Menu;
            })(Menu = Controller.Menu || (Controller.Menu = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Menu;
            (function (Menu) {
                class Item extends HTML.Container {
                    setClick() {
                        const me = this;
                        this.onClick((e) => {
                            me.handleClick(e);
                        });
                    }
                    handleClick(e) {
                        const click = this.get("click");
                        if (click && click.func) {
                            this.processFunction(HA.toMap(click));
                        }
                    }
                    processFunction(data) {
                        const navigationService = this.getNavigationService();
                        switch (data.get("func")) {
                            case "toggleApp":
                                navigationService.toggleApp(data);
                                break;
                            case "showApp":
                                navigationService.showApp(data);
                                break;
                            case "reloadApp":
                                navigationService.reloadApp(data);
                                break;
                            case "service":
                                const service = this.getService(data.get("id"));
                                service.process(data);
                                break;
                            default:
                                break;
                        }
                    }
                    getNavigationService() {
                        return this.getService("ha.service.webpage");
                    }
                    initialize(data) {
                        super.initialize(data);
                        if (this.get("click")) {
                            this.setClick();
                        }
                    }
                }
                Menu.Item = Item;
            })(Menu = HTML.Menu || (HTML.Menu = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Menu;
            (function (Menu) {
                var Item = HA.Core.HTML.Menu.Item;
                class MenuItem extends Controller.Controller {
                    initialize(data) {
                        super.initialize(data);
                        if (!data.has("no-init")) {
                            this.addToData("tag", new Item(data));
                        }
                    }
                }
                Menu.MenuItem = MenuItem;
            })(Menu = Controller.Menu || (Controller.Menu = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Navigation;
            (function (Navigation) {
                class Item extends HTML.Container {
                }
                Navigation.Item = Item;
            })(Navigation = HTML.Navigation || (HTML.Navigation = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Navigation;
            (function (Navigation) {
                class AppInfoItem extends Navigation.Item {
                    updateInfo(data) {
                        HA.log(['AppInfoItem::updateInfo', data]);
                    }
                    initialize(data) {
                        super.initialize(data);
                    }
                }
                Navigation.AppInfoItem = AppInfoItem;
            })(Navigation = HTML.Navigation || (HTML.Navigation = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Navigation;
            (function (Navigation) {
                var Item = HA.Core.HTML.Navigation.Item;
                class NavigationItem extends Controller.Controller {
                    initialize(data) {
                        super.initialize(data);
                        const hdata = new Map(data);
                        const me = this;
                        hdata.set("-events", HA.toMap({
                            click: () => {
                                me.click();
                            },
                        }));
                        hdata.delete("click");
                        this.createTag(hdata);
                    }
                    createTag(data) {
                        this.addToData("tag", new Item(data));
                    }
                }
                Navigation.NavigationItem = NavigationItem;
            })(Navigation = Controller.Navigation || (Controller.Navigation = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Navigation;
            (function (Navigation) {
                var AppInfoItem = HA.Core.HTML.Navigation.AppInfoItem;
                class AppInfo extends Navigation.NavigationItem {
                    updateInfo(data) {
                        let tag = this.getTag().findByAttribute("nav-app-name");
                        if (tag && data.get("appName")) {
                            tag.setText(data.get("appName"));
                        }
                        tag = this.getTag().findByAttribute("nav-app-title");
                        if (tag && data.get("appTitle")) {
                            tag.setText(data.get("appTitle"));
                        }
                        tag = this.getTag().findByAttribute("nav-app-icon");
                        if (tag && data.get("appIcon")) {
                            tag.setAttribute("src", data.get("appIcon"));
                        }
                    }
                    updateQmenu(quickMenus) {
                        const app = this.get("menuApp");
                        if (app) {
                            app.clear();
                            app.addItem(HA.toMap({
                                id: "main",
                                l: { classes: ["fad", "fa-hand-point-left"], _tn: "i", t: "t" },
                                n: "Revenir",
                                t: "showApp",
                            }));
                            quickMenus.forEach((qm) => {
                                const quickMenu = HA.toMap(qm);
                                app.addItem(HA.toMap({
                                    id: quickMenu.get("id"),
                                    t: quickMenu.get("t"),
                                    n: quickMenu.get("n"),
                                    l: quickMenu.get("l"),
                                }));
                            });
                        }
                    }
                    subscribeToAppInfo() {
                        const me = this;
                        this.getAppManager().subscribe("appInfo", (data) => {
                            me.updateInfo(data);
                        });
                        this.getAppManager().subscribe("qmenu", (data) => {
                            me.updateQmenu(data);
                        });
                    }
                    getAppManager() {
                        return this.getService("ha.service.appManager");
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.subscribeToAppInfo();
                        const app = new HA.Core.Entity.Menu(HA.toMap({
                            animation: this.get("animation"),
                            services: this.getServiceManager(),
                        }));
                        app.addItem(HA.toMap({ id: "main", t: "showApp", n: "Revenir" }));
                        this.addToData("menuApp", app);
                        app.setId("app.main.menu");
                        HA.getWebPageService().setQMenu(() => { this.click(); });
                    }
                    createTag(data) {
                        this.addToData("tag", new AppInfoItem(data));
                    }
                    click() {
                        const timer = setTimeout(() => {
                            if (!this.get("preventDClick")) {
                                const app2 = this.get("menuApp");
                                HA.getWebPageService().toggleApp(HA.toMap({ id: app2.getId(), app: app2 }));
                            }
                            this.addToData("preventDClick", false);
                        }, 200);
                        this.addToData("dclicktimer", timer);
                    }
                }
                Navigation.AppInfo = AppInfo;
            })(Navigation = Controller.Navigation || (Controller.Navigation = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Navigation;
            (function (Navigation) {
                class NavBack extends Navigation.Item {
                }
                Navigation.NavBack = NavBack;
            })(Navigation = HTML.Navigation || (HTML.Navigation = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Navigation;
            (function (Navigation) {
                var NavBackItem = HA.Core.HTML.Navigation.NavBack;
                class NavBack extends Navigation.NavigationItem {
                    createTag(data) {
                        this.addToData("tag", new NavBackItem(data));
                    }
                }
                Navigation.NavBack = NavBack;
            })(Navigation = Controller.Navigation || (Controller.Navigation = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Navigation;
            (function (Navigation_1) {
                class Navigation extends HTML.Container {
                    getTagName() {
                        return "nav";
                    }
                    initialize(data) {
                        super.initialize(data);
                        const color = this.translate("#bgColor");
                        const useTransparent = this.translate("#useTransparent");
                        if (color && useTransparent) {
                            HA.timeout(() => {
                                const nav = document.querySelector('nav');
                                window.addEventListener('scroll', function (event) {
                                    event.preventDefault();
                                    if (window.scrollY <= window.innerHeight) {
                                        nav.style.backgroundColor = 'transparent';
                                    }
                                    else {
                                        nav.style.backgroundColor = color;
                                    }
                                });
                                nav.style.backgroundColor = 'transparent';
                            }, 200);
                        }
                        else if (color) {
                            HA.timeout(() => {
                                const nav = document.querySelector('nav');
                                nav.style.backgroundColor = color;
                            }, 200);
                        }
                    }
                }
                Navigation_1.Navigation = Navigation;
            })(Navigation = HTML.Navigation || (HTML.Navigation = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Navigation;
            (function (Navigation_2) {
                var NavigationTag = HA.Core.HTML.Navigation.Navigation;
                var Anchor = HA.Core.HTML.Anchor;
                class Navigation extends Controller.Controller {
                    static createItemController(data) {
                        if (data.has("controllerName")) {
                            return HA.createService(HA.Core.Controller.Navigation, data.get("controllerName"), data);
                        }
                        return new Navigation_2.NavigationItem(data);
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.addToData("tag", new NavigationTag(HA.toMap(data)));
                        this.initAnchors();
                        if (this.has("skip")) {
                            return;
                        }
                        this.initializeItems();
                    }
                    initAnchors(tag) {
                        tag = tag || this.getTag();
                        const anchors = tag.fetchByTagName("a");
                        anchors.forEach((anchor) => {
                            if (anchor.getAttribute("i")) {
                                return;
                            }
                            anchor.setAttribute("i", "1");
                            const data = new Map();
                            data.set("tag", anchor);
                            data.set("services", HA.getService4App());
                            new Anchor(data);
                        });
                    }
                    initializeItems() {
                        this.addToData("itemControllers", new Map());
                        const items = this.getItems();
                        if (items) {
                            const me = this;
                            items.forEach((item) => {
                                me.addItem(HA.toMap(item));
                            });
                        }
                    }
                    addItem(data) {
                        const config = HA.toMap(data);
                        config.set("services", this.getItemService());
                        config.set("pelement", this.getTag());
                        this.getItemControllers().set(data.get("id"), Navigation.createItemController(config));
                    }
                    getItemService() {
                        return this.get("services");
                    }
                    getItemControllers() {
                        return this.get("itemControllers");
                    }
                    getItems() {
                        return this.get("items");
                    }
                }
                Navigation_2.Navigation = Navigation;
            })(Navigation = Controller.Navigation || (Controller.Navigation = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Navigation;
            (function (Navigation) {
                class UserItem extends Navigation.Item {
                    updateImage(data) {
                        return this.getImageTag().src = data.get("src");
                    }
                    isConnected() {
                        this.addClass("connected");
                        const tag = this.findById(this.getImageId());
                        if (tag) {
                            tag.addClass("connected");
                        }
                    }
                    disconnected() {
                        this.removeClass("connected");
                        const tag = this.findById(this.getImageId());
                        if (tag) {
                            tag.removeClass("connected");
                        }
                    }
                    getImageTag() {
                        return this.get("image");
                    }
                    getImageId() {
                        return this.get("imageId");
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.addToData("image", this.findElementById(this.getImageId()));
                    }
                }
                Navigation.UserItem = UserItem;
            })(Navigation = HTML.Navigation || (HTML.Navigation = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Navigation;
            (function (Navigation) {
                var UserItem = HA.Core.HTML.Navigation.UserItem;
                class NavigationUser extends Navigation.NavigationItem {
                    updateUser(data) {
                        if (data.has("picture")) {
                            this.getTag().updateImage(HA.toMap({ src: data.get("picture") }));
                            if (data.get("picture") !== "/file/ha/svg/user") {
                                this.getTag().isConnected();
                            }
                            else {
                                this.getTag().disconnected();
                            }
                        }
                    }
                    subscribeToUser() {
                        const me = this;
                        this.getUserService().subscribe((data) => {
                            me.updateUser(data);
                        });
                    }
                    getUserService() {
                        return this.getService("ha.service.user");
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.subscribeToUser();
                    }
                    createTag(data) {
                        this.addToData("tag", new UserItem(data));
                    }
                }
                Navigation.NavigationUser = NavigationUser;
            })(Navigation = Controller.Navigation || (Controller.Navigation = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var EntryItem = HA.Core.HTML.HAList.EntryItem;
            class ResultItem extends EntryItem {
            }
            HTML.ResultItem = ResultItem;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Page;
            (function (Page) {
                var List = HA.Core.HTML.List;
                var ResultItem = HA.Core.HTML.ResultItem;
                var CFlexContainer = HA.Core.HTML.CFlexContainer;
                class SearchableController extends Page.ResultListController {
                    initialize(data) {
                        super.initialize(data);
                        const c = new CFlexContainer();
                        const me = this;
                        const l = new List({ entryClass: this.getResultItem() });
                        if (data.has("pfunc") && data.get("pfunc").itemClick) {
                            l.setItemClick(data.get("pfunc").itemClick);
                        }
                        if (this.showSearchBox()) {
                            const sbox = new Page.SearchBoxController({
                                kup: (txt) => {
                                    me.search(txt);
                                },
                            });
                            c.appendChild(sbox);
                        }
                        c.appendChild(l);
                        this.addToData("listTag", l);
                        let parentCont = this.get("parentTag");
                        if (parentCont) {
                            const list = parentCont.fetchByAttribute('rl');
                            if (list.length > 0) {
                                parentCont = list[0];
                            }
                        }
                        parentCont.appendChild(c);
                        this.addToData("tag", c);
                        this.addItems(this.get("d"));
                        const is = this.get("is");
                        if (is) {
                            this.addToData("is", HA.toMap(is));
                            this.addToData("sd", HA.toMap(is));
                            HA.getWebPageService().subscribeToAppInfo(() => {
                                if (me.isActive()) {
                                    me.initWatch4Reload();
                                }
                            });
                            this.initWatch4Reload();
                        }
                    }
                    getResultItem() {
                        return ResultItem;
                    }
                    showSearchBox() {
                        return this.get("showSearchBox") !== "no";
                    }
                    search(txt) {
                        const is = this.get("sd") || new Map();
                        is.set("q", txt);
                        is.set("los", 0);
                        this.addToData("is", HA.toMap(is));
                        this.getListTag().clear();
                        this.infiniteReload();
                    }
                    initWatch4Reload() {
                        if (!this.isActive()) {
                            return;
                        }
                        this.unlock();
                        const me = this;
                        this.watch4Reload(() => {
                            me.infiniteReload();
                        });
                    }
                    unlock() {
                        this.addToData("lock", false);
                    }
                    lock() {
                        this.addToData("lock", true);
                    }
                    isLock() {
                        return this.get("lock") === true;
                    }
                    addItems(items) {
                        if (this.has("m")) {
                            const tag = this.getListTag();
                            tag.setModel(this.get("m"));
                            if (items) {
                                items.forEach((i) => {
                                    tag.addByModel(HA.toMap(i));
                                });
                            }
                        }
                    }
                    getListTag() {
                        return this.get("listTag");
                    }
                    getAppId() {
                        return this.get("appId");
                    }
                    isActive() {
                        return this.has("pfunc") || HA.getWebPageService().isActive(this.getAppId());
                    }
                    infiniteReload() {
                        const is = this.get("is");
                        if (!is || is.size < 1 || is.get("los") < 0) {
                            this.removeWatch4Reload();
                            return;
                        }
                        if (this.isLock()) {
                            return;
                        }
                        this.lock();
                        const me = this;
                        if (!me.isActive()) {
                            me.lock();
                            me.removeWatch4Reload();
                            return;
                        }
                        HA.getDataRepository().fetchData(is).then((response) => {
                            const success = response.get("success");
                            if (success) {
                                const data = HA.toMap(response.get("d"));
                                if (data) {
                                    me.addItems(data.get("l"));
                                }
                                me.addToData("is", HA.toMap(data.get("is")));
                                if (!me.isActive()) {
                                    me.lock();
                                    me.removeWatch4Reload();
                                    return;
                                }
                            }
                            else {
                                if (response.has("t")) {
                                    HA.getAppService().processAction(response);
                                }
                                else if (response.has("msg")) {
                                    HA.log(response.get("msg"));
                                }
                            }
                            me.unlock();
                        }).catch((reason) => {
                            HA.log2(["err::searchCtrl", reason, is]);
                            me.unlock();
                        });
                    }
                }
                Page.SearchableController = SearchableController;
            })(Page = Controller.Page || (Controller.Page = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Menu;
            (function (Menu) {
                class MenuList extends HTML.ResultItem {
                    initialize(data) {
                        super.initialize(data);
                        const b = this.findByAttribute("body");
                        const list = new HTML.List({ classes: ["fc", "fw"] });
                        this.addToData("ml", list);
                        if (b) {
                            b.appendChild(this.getMenuList());
                            this.addItems(this.get("mid"));
                        }
                    }
                    addItems(items) {
                        if (this.has("mim")) {
                            const tag = this.getMenuList();
                            tag.setModel(this.get("mim"));
                            if (items) {
                                items.forEach((i) => {
                                    tag.addByModel(HA.toMap(i));
                                });
                            }
                        }
                    }
                    getMenuList() {
                        return this.get("ml");
                    }
                }
                Menu.MenuList = MenuList;
            })(Menu = HTML.Menu || (HTML.Menu = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Page;
            (function (Page) {
                var MenuList = HA.Core.HTML.Menu.MenuList;
                class MenuController extends Page.SearchableController {
                    showSearchBox() {
                        return false;
                    }
                    getResultItem() {
                        return MenuList;
                    }
                }
                Page.MenuController = MenuController;
            })(Page = Controller.Page || (Controller.Page = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form_1) {
                class Form extends HTML.List {
                    getTagName() {
                        return "form";
                    }
                }
                Form_1.Form = Form;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Page;
            (function (Page) {
                var Tag = HA.Core.HTML.Tag;
                var Form = HA.Core.HTML.Form.Form;
                var FormController = HA.Core.Controller.Form.FormController;
                var HtmlService = HA.Core.HTML.Service.HtmlService;
                var Anchor = HA.Core.HTML.Anchor;
                var Div = HA.Core.HTML.Div;
                class PageController extends Controller.Controller {
                    initialize(data) {
                        super.initialize(data);
                        this.createHtml();
                        this.initForms();
                        this.initControllers();
                        this.createMenu();
                    }
                    createMenu() {
                        const controllersData = HA.toMap(this.get("controllers"));
                        if (!controllersData || !controllersData.get("pm")) {
                            return;
                        }
                        const pm = HA.toMap(controllersData.get("pm"));
                        if (pm.size > 0) {
                            const tag = this.getTag();
                            const t = tag.findByAttribute("tt=pa");
                            if (t) {
                                const div = new Tag({
                                    c: [
                                        {
                                            attributes: [
                                                {
                                                    n: "id",
                                                    v: "pagemenu",
                                                },
                                            ],
                                            classes: ["xscroll", "ayyellow"],
                                            t: "fc",
                                        }
                                    ],
                                    class: "fixp",
                                });
                                t.addFistChild(div);
                                const flexContainer = div.findById("pagemenu");
                                pm.forEach((item) => {
                                    const content = item.html ? [item.html] : item.n;
                                    const d = new Div({
                                        c: content,
                                        class: "item",
                                    });
                                    const a = new Anchor(HA.toMap({
                                        attributes: [
                                            {
                                                n: "d",
                                                v: item.a,
                                            },
                                            {
                                                n: "t",
                                                v: "reloadApp",
                                            },
                                        ],
                                    }));
                                    a.appendChild(d);
                                    flexContainer.appendChild(a);
                                });
                            }
                        }
                    }
                    createHtml() {
                        if (this.get("pd")) {
                            this.getTag().addClass("app_page");
                            this.getTag().appendChild(HtmlService.createHtml(HA.toMap(this.get("pd")), this.getServiceManager()));
                        }
                    }
                    initForms() {
                        const tag = this.getTag();
                        const forms = tag.fetchByTagName("form");
                        forms.forEach((form) => {
                            if (form.getAttribute("i")) {
                                return;
                            }
                            const data = new Map();
                            data.set("tag", new Form(form));
                            new FormController(data);
                        });
                    }
                }
                Page.PageController = PageController;
            })(Page = Controller.Page || (Controller.Page = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class SearchBox extends HTML.Container {
                createSelf() {
                    const has = new HTML.FlexContainer({ className: "hasbox" });
                    const hai = new HTML.FlexContainer({ className: "haibox" });
                    const me = this;
                    const input = new HTML.Form.Input({
                        attributes: [
                            {
                                n: "placeholder",
                                v: "affiner la liste...",
                            },
                            {
                                n: "type",
                                v: "search",
                            },
                        ],
                        class: "searchbox"
                    });
                    input.addListener("keyup", (event) => {
                        me.change(event);
                    });
                    input.addListener("search", (event) => {
                        me.change(event);
                    });
                    this.addToData("itag", input);
                    hai.appendChild(new HTML.Div({
                        c: [
                            {
                                t: "t",
                                tag: input,
                            },
                        ],
                        className: "haic",
                    }));
                    const lense = hai.appendChild(new HTML.Div({
                        onClick: (event) => {
                            me.change(event, true);
                        },
                        html: "<div class=\"halense\">\n" +
                            "             <button class=\"hablense\">\n" +
                            "                 <svg focusable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n" +
                            "                     <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"></path>\n" +
                            "                 </svg>\n" +
                            "             </button>\n" +
                            "         </div>",
                    }));
                    has.appendChild(hai);
                    this.setElement(has.getElement());
                }
                getValue() {
                    return this.get("itag").getText();
                }
                change(event, force) {
                    if (force || event.keyCode === 13 || event.type === "search") {
                        const f = this.get("kup");
                        if (f) {
                            f(this.getValue());
                        }
                    }
                }
            }
            HTML.SearchBox = SearchBox;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var Controller;
        (function (Controller) {
            var Page;
            (function (Page) {
                var SearchBox = HA.Core.HTML.SearchBox;
                class SearchBoxController extends Controller.Controller {
                    initialize(data) {
                        super.initialize(data);
                        this.createSearchBox();
                    }
                    createSearchBox() {
                        this.addToData("tag", new SearchBox(this.getData()));
                    }
                }
                Page.SearchBoxController = SearchBoxController;
            })(Page = Controller.Page || (Controller.Page = {}));
        })(Controller = Core.Controller || (Core.Controller = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class GMap extends HTML.Div {
                createSelf() {
                    super.createSelf();
                    const map = new google.maps.Map(this.getElement(), {
                        center: this.get("center"),
                        zoom: this.get("zoom")
                    });
                    new google.maps.Marker({
                        position: this.get("center"),
                        map: map,
                    });
                }
            }
            HTML.GMap = GMap;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var TBox;
            (function (TBox) {
                class Section extends HTML.Pane {
                    createItem(data) {
                        const _d = data.get("d");
                        switch (data.get("t")) {
                            case "l":
                                return new TBox.ItemList({ d: _d });
                            case "sl":
                                return new TBox.SimpleItemList({ d: _d });
                            case "p":
                                const t = new HTML.Div(_d);
                                t.addClass("p");
                                return t;
                            case "t":
                                const t2 = new HTML.Div(_d);
                                t2.addClass("t2");
                                return t2;
                            default:
                                return null;
                        }
                    }
                    createSelf() {
                        super.createSelf();
                        this.addClass("sect");
                        const me = this;
                        const tdata = this.get("d");
                        if (tdata) {
                            tdata.forEach((item) => {
                                me.appendChild(me.createItem(HA.toMap(item)));
                            });
                        }
                    }
                }
                TBox.Section = Section;
            })(TBox = HTML.TBox || (HTML.TBox = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Section = HA.Core.HTML.TBox.Section;
            class TextBox extends HTML.Box {
                createByType(data) {
                    switch (data.get("t")) {
                        case "s":
                            return new Section({ d: data.get("d") });
                        case "t1":
                            const tag = new HTML.Div(data.get("d"));
                            tag.addClass("t1");
                            return tag;
                        case "img":
                            return new HTML.Img(data.get("d"));
                        default:
                            return null;
                    }
                }
                createSelf() {
                    super.createSelf();
                    this.addClass("tbox");
                    const c = new HTML.CFlexContainer();
                    const me = this;
                    let tdata = this.get("tdata");
                    if (!tdata) {
                        tdata = this.getData();
                        tdata.forEach((item) => {
                            c.appendChild(new HTML.TextField(item));
                        });
                    }
                    else {
                        tdata.forEach((item) => {
                            c.appendChild(me.createByType(HA.toMap(item)));
                        });
                    }
                    this.appendChild(c);
                }
            }
            HTML.TextBox = TextBox;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class FlexItem extends HTML.Container {
                initialize(data) {
                    super.initialize(data);
                }
            }
            HTML.FlexItem = FlexItem;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class DSelector extends HTML.Window {
                    getSelections() {
                        const data = [];
                        this.getItems().forEach((s) => {
                            if (s && s.isChecked()) {
                                data.push(s.getValue());
                            }
                        });
                        return data;
                    }
                    getItems() {
                        return this.getList().getItems();
                    }
                    getList() {
                        return this.get("list");
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.appendChild(this.createHead());
                        this.addClass("ds");
                        if (this.has("sd")) {
                            this.initFromSD();
                        }
                        else {
                            this.initList();
                        }
                    }
                    initFromSD() {
                        const me = this;
                        HA.getDataRepository().fetchData(this.get("sd")).then((response) => {
                            const data = HA.toMap(response.get("app"));
                            if (me.has("pfunc")) {
                                data.set("pfunc", me.get("pfunc"));
                            }
                            const app = new HA.Core.Entity.App(data);
                            this.appendChild(app.getTag());
                        });
                    }
                    initList() {
                        const me = this;
                        const list = new HTML.List(new HTML.CFlexContainer());
                        list.addClass("dl");
                        const dataList = this.get("dlist");
                        if (dataList) {
                            dataList.forEach((data) => {
                                list.addItem(me.createItem(data));
                            });
                        }
                        this.addToData("list", list);
                        this.appendChild(list);
                    }
                    createHead(data) {
                        return new HTML.SelectorHead(data);
                    }
                    createItem(data) {
                        if (this.has("pfunc")) {
                            data.set("pfunc", this.get("pfunc").itemClick);
                        }
                        return new Editor.SelectorItem(data);
                    }
                }
                Editor.DSelector = DSelector;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class ImageItem extends Editor.SelectorItem {
                }
                Editor.ImageItem = ImageItem;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class RadioGroup extends HTML.FlexContainer {
                    addRadios(radios) {
                        radios.forEach((rd) => {
                            this.addRadio(rd.r, rd.l);
                        });
                    }
                    addRadio(radio, label) {
                        const c = new HTML.CFlexContainer();
                        const radioEl = new Form.Radio(radio);
                        const me = this;
                        radioEl.onChange((e) => { me.onRadioChange(radio); });
                        c.appendChild(radioEl);
                        c.appendChild(new Form.Label(label));
                        const c2 = new HTML.Container();
                        c2.appendChild(c);
                        this.appendChild(c2);
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.spaceAround();
                        const radios = this.get("radios");
                        if (radios) {
                            this.addRadios(radios);
                        }
                    }
                    onRadioChange(e) {
                        const func = this.get("onRadioChange");
                        func(e);
                    }
                }
                Form.RadioGroup = RadioGroup;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Input extends HTML.Tag {
                    getText() {
                        return this.getElement().value;
                    }
                    clear() {
                        this.getElement().value = "";
                        return this;
                    }
                    setText(value) {
                        this.getElement().value = value;
                    }
                    getTagName() {
                        return "input";
                    }
                }
                Form.Input = Input;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class SelectorHead extends HTML.Container {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("dsh");
                }
            }
            HTML.SelectorHead = SelectorHead;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var RadioGroup = HA.Core.HTML.Form.RadioGroup;
            var Input = HA.Core.HTML.Form.Input;
            class MultiTextHead extends HTML.SelectorHead {
                static dataURLtoFile(dataUrl, filename) {
                    const arr = dataUrl.split(",");
                    const mime = arr[0].match(/:(.*?);/)[1];
                    const bstr = atob(arr[1]);
                    let n = bstr.length;
                    const u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new File([u8arr], filename, { type: mime });
                }
                static urlToFile(url, name) {
                    if (url.indexOf("data", 0) === 0) {
                        return MultiTextHead.dataURLtoFile(url, name);
                    }
                    return (fetch("/file/?redirect=" + url)
                        .then((res) => {
                        return res.arrayBuffer();
                    })
                        .then((buf) => {
                        return new File([buf], name, { type: "image/png" });
                    }));
                }
                initialize(data) {
                    super.initialize(data);
                    this.addClass("dsh");
                    this.addClass("mtxteh");
                    this.createRadioOption();
                    this.createTxtAdder();
                }
                getTextField() {
                    return this.get("tf");
                }
                getEditor() {
                    return this.get("ed");
                }
                addText() {
                    if (this.isType("img") || this.isType("file")) {
                        const fileInput = this.getTextField();
                        this.getEditor().addImageFiles(fileInput.getFiles());
                        fileInput.clear();
                    }
                    else if (this.isType("url")) {
                        const input = this.getTextField();
                        const file = MultiTextHead.urlToFile(input.getText(), "image");
                        if (file instanceof Promise) {
                            const me = this;
                            file.then((f) => {
                                me.getEditor().addImageFile(f);
                                input.clear().focus();
                            });
                        }
                        else {
                            this.getEditor().addImageFile(file);
                            input.clear().focus();
                        }
                    }
                    else if (this.isType("json")) {
                        const fileInput = this.getTextField();
                        this.getEditor().addFiles(fileInput.getFiles());
                        fileInput.clear();
                    }
                    else {
                        const input = this.getTextField();
                        this.getEditor().addText(input.getText());
                        input.clear().focus();
                    }
                }
                createRadioOption() {
                    if (!this.isType("img/url")) {
                        return null;
                    }
                    const me = this;
                    const radioGroup = new RadioGroup(HA.toMap({
                        radios: [
                            {
                                l: {
                                    attributes: [
                                        {
                                            n: "for",
                                            v: "url",
                                        },
                                    ],
                                    txt: "URL",
                                },
                                r: {
                                    attributes: [
                                        {
                                            n: "id",
                                            v: "url",
                                        },
                                        {
                                            n: "value",
                                            v: "url",
                                        },
                                        {
                                            n: "checked",
                                            v: "checked",
                                        },
                                        {
                                            n: "name",
                                            v: "file_url",
                                        },
                                    ],
                                    rid: "url",
                                },
                            },
                            {
                                l: {
                                    attributes: [
                                        {
                                            n: "for",
                                            v: "file",
                                        },
                                    ],
                                    txt: "Fichier",
                                },
                                r: {
                                    attributes: [
                                        {
                                            n: "id",
                                            v: "file",
                                        },
                                        {
                                            n: "value",
                                            v: "file",
                                        },
                                        {
                                            n: "name",
                                            v: "file_url",
                                        },
                                    ],
                                    rid: "file",
                                },
                            },
                        ],
                        onRadioChange: (r) => {
                            me.onRadioChange(r);
                        },
                    }));
                    this.appendChild(radioGroup);
                }
                isType(type) {
                    return this.getType() === type;
                }
                getType() {
                    return this.get("t");
                }
                getInputContainer() {
                    if (this.hasNot("icont")) {
                        this.addToData("icont", new HTML.Container({ className: "flex3" }));
                    }
                    return this.get("icont");
                }
                replaceInputByType() {
                    let tf = null;
                    switch (this.getType()) {
                        case "img":
                        case "file":
                        case "json":
                            const me = this;
                            tf = new HA.Core.HTML.Form.FileInput(HA.toMap({
                                accept: this.get("accept"),
                                max: this.get("max"),
                                oc: () => {
                                    me.addText();
                                },
                            }));
                            break;
                        case "img/url":
                            this.addToData("t", "url");
                        case "url":
                        default:
                            tf = new Input();
                            break;
                    }
                    tf.addClass("txtl");
                    const c = this.getInputContainer();
                    c.clear();
                    c.appendChild(tf);
                    this.addToData("tf", tf);
                    if (this.get("tc") && tf instanceof HA.Core.HTML.Form.FileInput) {
                        tf.triggerClick();
                    }
                }
                createTxtAdder() {
                    const me = this;
                    const c = new HTML.FlexContainer();
                    const btn = new HTML.Form.Button({
                        click: () => {
                            me.addText();
                        },
                        v: "ajouter",
                    });
                    c.appendChild(this.getInputContainer());
                    c.appendChild(btn);
                    this.replaceInputByType();
                    this.appendChild(c);
                }
                onRadioChange(e) {
                    this.addToData("t", e.rid);
                    this.replaceInputByType();
                }
            }
            HTML.MultiTextHead = MultiTextHead;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Editor;
            (function (Editor) {
                class TextItem extends Editor.SelectorItem {
                }
                Editor.TextItem = TextItem;
            })(Editor = HTML.Editor || (HTML.Editor = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class FileInput extends HTML.Tag {
                    triggerClick() {
                        const element = this.get("input").getElement();
                        element.click();
                    }
                    getFiles() {
                        return this.get("files");
                    }
                    clear() {
                        this.getFilenameDiv().setText("selectionnez un fichier...");
                        return this;
                    }
                    inputHasChanged(event) {
                        const files = event.target.files;
                        const filename = (files.length > 1) ? files[0].name + " " + (files.length) + " fichiers" : files[0].name;
                        this.getFilenameDiv().setText(filename);
                        this.addToData("files", files);
                    }
                    getText() {
                        return this.getElement().value;
                    }
                    setText(value) {
                        return this.getElement().value = value;
                    }
                    initialize(data) {
                        if (data === undefined) {
                            data = HA.toMap({});
                        }
                        data.set("element", HTML.Tag.createElement("div"));
                        super.initialize(data);
                        const me = this;
                        const input = new Form.Input(HA.toMap({
                            onChange: (event) => {
                                me.inputHasChanged(event);
                                if (data.has("oc")) {
                                    data.get("oc")();
                                }
                            },
                        }));
                        if (this.hasNot("max") || this.get("max") > 1) {
                            input.setAttribute("multiple", 1);
                        }
                        const filename = new HTML.Div("selectionnez un fichier...");
                        this.addToData("input", input);
                        this.addToData("filename", filename);
                        input.setAttribute("type", "file");
                        if (data.get("accept")) {
                            input.setAttribute("accept", data.get("accept"));
                        }
                        input.invisible();
                        this.appendChild(filename);
                        this.appendChild(input);
                        filename.addClass("fname");
                    }
                    getFilenameDiv() {
                        return this.get("filename");
                    }
                }
                Form.FileInput = FileInput;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Label extends HTML.Tag {
                    getTagName() {
                        return "label";
                    }
                }
                Form.Label = Label;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Radio extends Form.Input {
                    getText() {
                        return this.getElement().value;
                    }
                    clear() {
                        this.getElement().value = "";
                        return this;
                    }
                    setText(value) {
                        this.getElement().value = value;
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.setAttribute("type", "radio");
                    }
                }
                Form.Radio = Radio;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Textarea extends HTML.Tag {
                    getText() {
                        return this.getElement().value;
                    }
                    clear() {
                        this.getElement().value = "";
                        return this;
                    }
                    setText(value) {
                        this.getElement().value = value;
                    }
                    getTagName() {
                        return "textarea";
                    }
                    createSelf() {
                        super.createSelf();
                        this.getElement().textContent = this.get("v");
                    }
                }
                Form.Textarea = Textarea;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var DSelector = HA.Core.HTML.Editor.DSelector;
            class UImg extends HTML.Container {
                getImg() {
                    return this.get("img");
                }
                createSelf() {
                    super.createSelf();
                    this.addClass("uimg");
                    const fc = this.get("fc");
                    const cont = fc ? new HTML.FlexContainer() : new HTML.CFlexContainer();
                    const img = new HTML.Img(HA.toMap({
                        alt: this.get("ti"),
                        h: this.get("h"),
                        load: this.get("loading"),
                        src: this.getImageSrc(),
                        w: this.get("w"),
                    }));
                    this.addToData("img", img);
                    this.appendChild(cont);
                    const imgC = new HTML.Div({ class: "imgc" });
                    imgC.appendChild(img);
                    cont.appendChild(imgC);
                    if (this.has("ti")) {
                        const ti = new HTML.Div(this.translate(this.get("ti")));
                        ti.addClass("ti");
                        cont.appendChild(ti);
                    }
                    const sd = this.get("sd");
                    if (sd && sd !== "") {
                        const ctac = new HTML.Div({ classes: ["ctac", "btnShadow"] });
                        const cta = new HTML.Tag({ html: "<i></i>", classes: ["rimg", "fad", "fa-camera"] });
                        this.addToData("cta", ctac);
                        ctac.appendChild(cta);
                        cont.appendChild(ctac);
                        this.getCTA().onClick(() => {
                            this.handleClick();
                        });
                    }
                }
                getCTA() {
                    return this.get("cta");
                }
                closeModal() {
                    HA.getAppService().closeFSApp(this.getAppId());
                }
                handleClick() {
                    const app2 = HA.Core.Service.App.createFSApp(this.loadSelector());
                    this.setAppId(app2.getId());
                    this.showModal(app2);
                }
                loadSelector() {
                    if (this.has("selector")) {
                        return this.get("selector");
                    }
                    const sd = this.translateAll(HA.toMap(this.get("sd")));
                    if (sd.get("dst") === "url") {
                        this.addToData("dst", "url");
                        return this.createDSelector(sd);
                    }
                    this.addToData("dst", "file");
                    return this.createMediaSelector(sd);
                }
                createDSelector(sd) {
                    const me = this;
                    const selector = new DSelector(HA.toMap({
                        pfunc: {
                            itemClick: (d) => {
                                me.itemClicked(d);
                            },
                        },
                        sd,
                        waccept: () => {
                            me.closeModal();
                        },
                        wcancel: () => {
                            me.closeModal();
                        },
                    }));
                    this.addToData("selector", selector);
                    return selector;
                }
                createMediaSelector(sd) {
                    const me = this;
                    const selector = new HA.Core.HTML.Editor.MultiMedia(HA.toMap({
                        max: 1,
                        pfunc: {
                            itemClick: (d) => {
                                me.itemClicked(d);
                            },
                        },
                        sd,
                        t: "img",
                        tc: 1,
                        waccept: () => {
                            me.closeModal();
                        },
                        wcancel: () => {
                            me.closeModal();
                        },
                    }));
                    this.addToData("selector", selector);
                    return selector;
                }
                itemClicked(data) {
                    this.closeModal();
                    if (this.get("dst") === "url") {
                        this.addToData("mid", data);
                        const udata = this.translateAll(this.get("udata"));
                        udata.set("mid", data);
                        this.getImg().updateSrc(this.getImageSrc());
                        HA.getDataRepository().saveData(udata).then((response) => {
                            HA.log("enrégistré!");
                        });
                        return;
                    }
                    const f = data[0].getFile();
                    HA.log2(f);
                    this.getImg().updateSrc(data[0].getFileData());
                    const form = new FormData();
                    form.append("media", f);
                    form.append("formId", this.get("formid"));
                    HA.getDataRepository().saveForm(form).then((response) => {
                        HA.getAppService().processAction(response);
                    }).catch((reason) => {
                        HA.log(["eRRRR", reason]);
                    });
                }
                getImageSrc() {
                    let prefix = this.trans("imb");
                    let suffix = "";
                    const mid = this.translate(this.get("mid"));
                    if (!prefix && ((mid && !mid.startsWith("http")) || !mid)) {
                        prefix = "/media/img/";
                    }
                    if (prefix === "-") {
                        prefix = "";
                    }
                    else {
                        suffix = this.get("h") ? "?h=" + this.get("h") + "&w=" + this.get("w") : "";
                    }
                    return (prefix || "") + mid + suffix;
                }
                setAppId(id) {
                    return this.addToData("_appId", id);
                }
                showModal(app) {
                    HA.getAppService().showFSApp(app);
                }
                getAppId() {
                    return this.get("_appId");
                }
            }
            HTML.UImg = UImg;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Media;
            (function (Media) {
                class Gallery extends HTML.Container {
                    createSelf() {
                        super.createSelf();
                        this.addClass("gallery");
                        const gallery = this.get("medias");
                        const total = gallery.length;
                        const fc = this.get("fc");
                        const cont = fc ? new HTML.FlexContainer() : new HTML.CFlexContainer();
                        const ctac = new HTML.Div({ class: "gcta", txt: total + " image(s)" });
                        this.addToData("cta", ctac);
                        const uimg = new HTML.UImg({ mid: gallery[0] });
                        uimg.appendChild(ctac);
                        cont.appendChild(uimg);
                        cont.onClick(() => {
                            this.handleClick();
                        });
                        this.appendChild(cont);
                    }
                    getCTA() {
                        return this.get("cta");
                    }
                    closeModal() {
                        HA.getAppService().closeFSApp(this.getAppId());
                    }
                    handleClick() {
                        const app2 = HA.Core.Service.App.createFSApp(this.loadGallery());
                        this.setAppId(app2.getId());
                        this.showModal(app2);
                    }
                    loadGallery() {
                        const me = this;
                        const cont = new HTML.Window(HA.toMap({
                            wcancel: () => {
                                me.closeModal();
                            },
                        }));
                        const sc = [];
                        const name = this.get("name");
                        const medias = this.get("medias");
                        const t = medias.length;
                        let p = 1;
                        medias.forEach((id) => {
                            sc.push({
                                "t": "div",
                                "class": "imgc",
                                "c": [
                                    {
                                        "t": "uimg",
                                        "ti": name + " " + (p++) + "/" + t,
                                        "mid": id
                                    }
                                ]
                            });
                        });
                        cont.appendChild(new HTML.Slider({
                            "t": "slider",
                            "class": "swiper",
                            "pagination": true,
                            "prev": true,
                            "next": true,
                            "scrollbar": true,
                            "sc": sc
                        }));
                        return cont;
                    }
                    showModal(app) {
                        HA.getAppService().showFSApp(app);
                    }
                    setAppId(id) {
                        return this.addToData("_appId", id);
                    }
                    getAppId() {
                        return this.get("_appId");
                    }
                }
                Media.Gallery = Gallery;
            })(Media = HTML.Media || (HTML.Media = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Menu;
            (function (Menu) {
                class AppMenuItem extends HTML.FlexContainer {
                    getNavigationService() {
                        return this.getService("ha.service.webpage");
                    }
                    initialize(data) {
                        super.initialize(data);
                        this.addClass("mi");
                        const ic = new HTML.FlexContainer();
                        const icon = new HTML.I();
                        if (Array.isArray(data.get("i"))) {
                            icon.addClasses(data.get("i"));
                        }
                        else {
                            icon.addClass(data.get("i"));
                        }
                        ic.addClass("iconc");
                        ic.appendChild(icon);
                        this.appendChild(ic);
                        this.appendChild(new HTML.TextField(data.get("n")));
                    }
                }
                Menu.AppMenuItem = AppMenuItem;
            })(Menu = HTML.Menu || (HTML.Menu = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class MenuItem extends HTML.Box {
                createSelf() {
                    super.createSelf();
                    this.addClass("menui");
                    const cont = new HTML.FlexContainer();
                    const logo = this.get("l");
                    if (logo instanceof Object) {
                        const img2 = new HTML.Div(HA.toMap(logo));
                        img2.addClass("medc");
                        cont.appendChild(img2);
                    }
                    else {
                        const img = new HTML.Div();
                        img.addClass("medc");
                        img.appendChild(new HTML.Img(HA.toMap({ src: logo })));
                        cont.appendChild(img);
                    }
                    cont.appendChild(new HTML.TextField(this.get("n")));
                    this.appendChild(cont);
                }
            }
            HTML.MenuItem = MenuItem;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class MenuPane extends HA.Core.HTML.Box {
                clear() {
                    this.getItems().clear();
                    return this;
                }
                addItem(data) {
                    data.set("click", () => {
                        this.handleClick(data);
                    });
                    this.getItems().addItem(new HTML.MenuItem(data));
                }
                handleClick(data) {
                    const a = data.get("a");
                    const service = HA.getAppService();
                    if (a instanceof Map || a instanceof Array) {
                        service.processAction(HA.toMap(a));
                        return;
                    }
                    service.processAction(HA.toMap({ id: data.get("id"), t: "reloadApp" }));
                }
                createSelf() {
                    super.createSelf();
                    this.addClass("menupane");
                    const items = new HTML.List({ tag: new HTML.CFlexContainer({ class: "menus" }) });
                    this.appendChild(items);
                    this.addToData("items", items);
                }
                createItems() {
                    const items = this.get("i");
                    const me = this;
                    if (items) {
                        items.forEach((i) => {
                            me.addItem(HA.toMap(i));
                        });
                    }
                }
                initialize(data) {
                    super.initialize(data);
                    this.createItems();
                }
                getItems() {
                    return this.get("items");
                }
            }
            HTML.MenuPane = MenuPane;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class ArticlePage extends HTML.Page {
                createByType(data, main) {
                    const t = data.get("t");
                    switch (t) {
                        default:
                            super.createByType(data, main);
                            break;
                    }
                }
                createSelf() {
                    super.createSelf();
                    this.addClass("pa-a");
                }
                getTagName() {
                    return "article";
                }
            }
            HTML.ArticlePage = ArticlePage;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class MenuPage extends HTML.Page {
                createSelf() {
                    super.createSelf();
                    this.addClass("pa-m");
                }
            }
            HTML.MenuPage = MenuPage;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class ResultListPage extends HTML.Page {
            }
            HTML.ResultListPage = ResultListPage;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Panel;
            (function (Panel) {
                class MediaPane extends HA.Core.HTML.Pane {
                    createSelf() {
                        super.createSelf();
                        this.addClass("mpane");
                    }
                }
                Panel.MediaPane = MediaPane;
            })(Panel = HTML.Panel || (HTML.Panel = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var TBox;
            (function (TBox) {
                class SimpleItemList extends HTML.Div {
                    createItem(data) {
                        return new TBox.SimpleListItem(data);
                    }
                    createSelf() {
                        super.createSelf();
                        this.addClass("sl");
                        const me = this;
                        const tdata = this.get("d");
                        tdata.forEach((item) => {
                            me.appendChild(this.createItem(item));
                        });
                    }
                }
                TBox.SimpleItemList = SimpleItemList;
            })(TBox = HTML.TBox || (HTML.TBox = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var TBox;
            (function (TBox) {
                class ItemList extends TBox.SimpleItemList {
                    createItem(data) {
                        return new TBox.ListItem(data);
                    }
                }
                TBox.ItemList = ItemList;
            })(TBox = HTML.TBox || (HTML.TBox = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var TBox;
            (function (TBox) {
                class SimpleListItem extends HTML.Div {
                    createSelf() {
                        super.createSelf();
                        this.addClass("i");
                    }
                }
                TBox.SimpleListItem = SimpleListItem;
            })(TBox = HTML.TBox || (HTML.TBox = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var TBox;
            (function (TBox) {
                class ListItem extends TBox.SimpleListItem {
                    initialize(data) {
                        data = "* " + data;
                        super.initialize(data);
                    }
                }
                TBox.ListItem = ListItem;
            })(TBox = HTML.TBox || (HTML.TBox = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Carousel extends HTML.Container {
                createSelf() {
                    super.createSelf();
                    this.addClass("carousel");
                    const list = new HTML.List(HA.toMap({
                        classes: ["feedl", "fc"],
                        d: this.get("d"),
                        m: this.get("m"),
                        trans: this.get("trans"),
                    }));
                    this.addToData("list", list);
                    this.appendChild(list);
                    if (this.get("show")) {
                        this.appendChild(new HTML.Div(HA.toMap({
                            classes: ["car-action", "car-action-l"],
                            t: "div",
                            txt: "<<",
                        })));
                        this.appendChild(new HTML.Div(HA.toMap({
                            classes: ["car-action", "car-action-r"],
                            t: "div",
                            txt: ">>",
                        })));
                    }
                }
            }
            HTML.Carousel = Carousel;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class Slider extends HTML.List {
                createSelf() {
                    super.createSelf();
                    let content;
                    const slides = [];
                    switch (this.get("ct")) {
                        case "m":
                            content = [{
                                    c: slides,
                                    class: "swiper-wrapper",
                                    d: this.get("d"),
                                    m: this.get("m"),
                                    t: "list",
                                }];
                            break;
                        default:
                            const slideContent = HA.toMap(this.get("sc"));
                            if (slideContent.size > 0) {
                                slideContent.forEach((sc) => {
                                    slides.push({
                                        c: [sc],
                                        class: "swiper-slide",
                                        t: "div",
                                    });
                                });
                            }
                            content = [{
                                    c: slides,
                                    class: "swiper-wrapper",
                                    t: "list",
                                }];
                    }
                    if (this.get("prev")) {
                        content.push({
                            class: "swiper-button-prev",
                            t: "div",
                        });
                    }
                    if (this.get("next")) {
                        content.push({
                            class: "swiper-button-next",
                            t: "div",
                        });
                    }
                    if (this.get("scrollbar")) {
                        content.push({
                            class: "swiper-scrollbar",
                            t: "div",
                        });
                    }
                    this.appendChildren((new HTML.Div({ c: content })).getChildren());
                }
            }
            HTML.Slider = Slider;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class ExtWindow extends HTML.Window {
                initialize(data) {
                    super.initialize(data);
                    this.initFrame(HA.toMap(data));
                }
                initFrame(d) {
                    d.delete("tag");
                    d.delete("element");
                    this.appendChild(new HA.Core.HTML.Iframe(d));
                }
            }
            HTML.ExtWindow = ExtWindow;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class WindowHead extends HTML.FlexContainer {
                initialize(data) {
                    super.initialize(data);
                    this.addClass("wh");
                    this.centered();
                    const title = new HTML.Div(this.get("title"));
                    title.addClass("t");
                    const cancel = new HTML.Div({ click: this.get("cancel") });
                    cancel.addClass("cancel");
                    this.appendChildRight(cancel);
                    this.appendChild(title);
                    if (this.get("accept")) {
                        const accept = new HTML.Div({ click: this.get("accept") });
                        accept.addClass("accept");
                        this.appendChildRight(accept);
                    }
                }
            }
            HTML.WindowHead = WindowHead;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Button extends Form.FormItem {
                    getType() {
                        return "Button";
                    }
                    createSelf() {
                        let btn = null;
                        if (this.hasNot("ft")) {
                            btn = new HTML.Div();
                            const v = this.get("v");
                            btn.addClass("buttonbox");
                            btn.setText(v);
                        }
                        else {
                            const icon = this.get("i");
                            let formClass = ["formi"];
                            let iconBox = undefined;
                            if (icon) {
                                iconBox = {
                                    t: "span",
                                    class: icon
                                };
                            }
                            if (this.has("class")) {
                                formClass.push(this.get("class"));
                            }
                            btn = new HTML.Tag({
                                attributes: [
                                    { n: "formi", v: 1 },
                                ],
                                c: [
                                    { t: "div", class: "state" },
                                    {
                                        c: [
                                            {
                                                c: [
                                                    {
                                                        attributes: [
                                                            { n: "ft", v: this.get("ft") },
                                                            { n: "formid", v: this.get("formid") },
                                                        ],
                                                        c: [iconBox, this.get("label")],
                                                        classes: ["buttonbox", "fc"],
                                                        t: "div",
                                                    }
                                                ],
                                                class: "b-box",
                                                t: "div",
                                            }
                                        ],
                                        class: "ibox",
                                        t: "div",
                                    },
                                ],
                                classes: formClass,
                                t: "div",
                            });
                        }
                        this.setElement(btn.getElement());
                    }
                    initialize(data) {
                        if (typeof data === "string") {
                            data = HA.toMap({ v: data });
                        }
                        super.initialize(data);
                    }
                }
                Form.Button = Button;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            var Form;
            (function (Form) {
                class Checkbox extends Form.FormItem {
                    getType() {
                        return "Checkbox";
                    }
                    getValue() {
                        return this.getITag().getAttribute("checked") !== undefined;
                    }
                    initialize(data) {
                        super.initialize(data);
                        let t = null;
                        if (this.getTag()) {
                            t = this.getTag().findByTag("input");
                        }
                        else {
                            t = this.findByTag("input");
                        }
                        this.addToData("itag", this.get("textarea") ? new Form.Textarea(t) : new Form.Input(t));
                        const me = this;
                        if (this.get("textarea")) {
                            const t = me.getITag();
                            const listenerF = () => {
                                if (me.has("remL")) {
                                    return;
                                }
                                t.fixHeight();
                                t.focus();
                                me.addToData("remL", true);
                            };
                            this.addListener("input", listenerF);
                            t.fixHeight();
                            t.focus();
                        }
                    }
                    createSelf() {
                        let input = null, val = this.trans("value");
                        const attrs = [
                            { n: "ft", v: "txtl" },
                            { n: "type", v: this.get("it") || "text" },
                            { n: "contenteditable", v: true },
                        ];
                        if (this.get("it") !== "date" && this.get("it") !== "datetime-local") {
                            attrs.push({ n: "placeholder", v: this.get("ph") || this.trans("label") });
                        }
                        else if (this.get("it") !== "datetime-local") {
                            if (val) {
                                const date = new Date(val);
                                val = date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
                            }
                        }
                        else {
                            attrs.push({ n: "min", v: this.trans("dtmin") });
                        }
                        attrs.push({ n: "value", v: val });
                        if (this.get("ft") === "txtl") {
                            input = {
                                attributes: attrs,
                                class: "textlinebox",
                                t: "input",
                                it: this.get("it"),
                            };
                        }
                        else {
                            input = {
                                attributes: [
                                    { n: "ft", v: "txt" },
                                    { n: "contenteditable", v: true },
                                    { n: "placeholder", v: this.get("ph") || this.trans("label") },
                                    { n: "value", v: this.trans("value") },
                                ],
                                class: "textbox",
                                t: "textarea",
                                v: this.trans("value"),
                            };
                        }
                        const c = this.createItemTag(input);
                        this.setElement(c.getElement());
                    }
                }
                Form.Checkbox = Checkbox;
            })(Form = HTML.Form || (HTML.Form = {}));
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class SelectEntry extends HTML.FlexContainer {
                getValue() {
                    const item = this.get("item");
                    let itemValue = null;
                    if (item instanceof HTML.TextItemEntry) {
                        itemValue = item.getValue();
                    }
                    return this.has("v") ? this.get("v") : (itemValue) ? itemValue : this.get("item");
                }
                equals(value) {
                    const current = this.getValue();
                    if (current instanceof HTML.Tag) {
                        return current.equals(value);
                    }
                    return this.getValue() === value;
                }
                initialize(data) {
                    if (typeof data === "string") {
                        data = HA.toMap({ v: data });
                    }
                    if (data instanceof HTML.Tag) {
                        data = HA.toMap({ item: data, tag: data });
                    }
                    super.initialize(data);
                }
                createSelf() {
                    const item = new HTML.FlexContainer();
                    const v = this.get("v");
                    if (v) {
                        item.appendChild(new HTML.Div(v));
                        item.setAttribute("v", v);
                    }
                    else if (this.has("item")) {
                        item.appendChild(this.get("item"));
                    }
                    item.addClass("sitem");
                    this.setElement(item.getElement());
                }
            }
            HTML.SelectEntry = SelectEntry;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
var HA;
(function (HA) {
    var Core;
    (function (Core) {
        var HTML;
        (function (HTML) {
            class TextItemEntry extends HTML.Tag {
                getValue() {
                    try {
                        const vTag = this.findByAttribute("v");
                        const v = JSON.parse(vTag.getAttribute("v"));
                        return v.v;
                    }
                    catch (e) {
                        return this.getAttribute("v");
                    }
                }
                equals(value) {
                    return this.getValue() === value;
                }
            }
            HTML.TextItemEntry = TextItemEntry;
        })(HTML = Core.HTML || (Core.HTML = {}));
    })(Core = HA.Core || (HA.Core = {}));
})(HA || (HA = {}));
